<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'home' }">{{
                $t("inicio")
              }}</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">
              <router-link :to="{ name: 'configuracion-carta' }">
                {{ $t("configuracionCarta") }}</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page" @click="contadorEasterEgg += 1">
              {{ $t("productosCarta") }}
            </li>
          </ol>
        </nav>
      </div>

      <div class="col-md-12">
        <div class="card">
          <div class="row">
            <div class="col-md-5">
              <div class="form-group">
                <label for="listBusiness"><strong>{{ $t("negocio") }}</strong></label>
                <el-select class="select-default" size="large" v-model="idBusiness" filterable @change="permisoCarta()"
                  :placeholder="this.$i18n.t('seleccionaNegocio')">
                  <el-option v-for="business in listBusinesses" class="select-primary" :value="business.id"
                    :label="business.establishmentName" :key="business.id">
                  </el-option>
                </el-select>
              </div>
            </div>

            <div class="col-md-5" v-if="listCartas.length > 1">
              <div class="form-group">
                <label><strong>{{ $t("cartaASecas") }}</strong></label>
                <el-select class="select-default" size="large" v-model="idCarta" @change="getProductosCarta()"
                  filterable :placeholder="$t('seleccionaUnaCarta')">
                  <el-option v-for="cart in listCartas" class="select-primary" :value="cart.id"
                    :label="cart.nombreMostrado" :key="cart.id">
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>
        </div>
      </div>

      <canvas id="myCanvas" :width="this.ancho" :height="this.alto" style="border: 1px solid #d3d3d3; display: none">
        Your browser does not support the HTML5 canvas tag.
      </canvas>
      <img :src="this.url" id="imagenMAMALONA" style="display: none" />
      <!--TABLA DE GESTION DE CONFIGURACION DE CARTA-->
      <template v-if="permiso === 1"> </template>
      <template v-else-if="permiso && respuesta && !isSelfi">
        <div class="col-md-4">
          <div class="form-group">
            <router-link :to="{
                name: 'producto-carta',
                params: { idBusiness: idBusiness, idCarta: idCarta },
              }">
              <button class="btn btn-primary">
                <i class="fa fa-plus-square"></i>
                {{ $t("agregarProductos") }}
              </button>
            </router-link>
            <!-- <button class="btn btn-warning" @click="getBusinessReplicado">
              <i class="far fa-clone"></i>
              {{ $t("replicarProductos") }}
            </button> -->

            <template v-if="listCartas.find((carta) => carta.id === idCarta).tiene_carta ===
                '1'
                ">
              <a target="_blank" :href="!esSelfi ?
                  'https://www.numier.com/carta/' +
                  listCartas.find((carta) => carta.id === idCarta).nameRoute :
                  'https://www.selfibar.com/carta-digital/carta/' +
                  listCartas.find((carta) => carta.id === idCarta).nameRoute + '/home'
                ">
                <button class="btn btn-info">
                  <i class="fas fa-book-open"></i> {{ $t("verCarta") }}
                </button>
              </a>
            </template>
            <template v-if="listCartas.find((carta) => carta.id === idCarta)
                  .tiene_pedidos === '1' && !esSelfi
                ">
              <a target="_blank" :href="'https://www.numier.com/pedidos/' +
                listCartas.find((carta) => carta.id === idCarta).nameRoute
                ">
                <button class="btn btn-info">
                  <i class="fas fa-boxes"></i> {{ $t("verPedido") }}
                </button>
              </a>
            </template>

            <template>
              <a target="_blank" :href="!esSelfi ?
                'https://www.numier.com/pdf/index.php?logo=' +
                listCartas.find((carta) => carta.id === idCarta)
                  .imagenLogoQR +
                '&nombreRuta=' +
                listCartas.find((carta) => carta.id === idCarta).nameRoute :
                'https://www.selfibar.com/pdf/index.php?logo=' +
                'https://www.selfibar.com/assets/images/selfibar-logo-azul.png' +
                '&nombreRuta=' +
                listCartas.find((carta) => carta.id === idCarta).nameRoute
                ">
                <button class="btn btn-danger">
                  <i class="fas fa-qrcode"></i> {{ $t("verQR") }}
                </button>
              </a>
            </template>

            <template>
              <button v-if="!editarProductos" @click="editarProductos = true" class="btn btn-warning">
                <i class="fas fa-edit"></i> {{ $t("editarPrecios") }}
              </button>
              <button v-if="editarProductos" @click="cancelarEdicion" class="btn btn-danger">
                <i class="fas fa-undo-alt"></i> {{ $t("cancelarEdicion") }}
              </button>
            </template>

            <!-- Exportar Carta -->
            <template v-if="listProductos.length > 0 && respuesta">
              <a :href="`${$store.getters.apiUrl}/products/exportCarta/PDF?idBusiness=${idBusiness}&filter=${filter}&jwt=${$store.getters.jwt}`">
                <button class="btn btn-primary">
                  <i class="fa fa-file-pdf"></i> {{ $t("exportarCarta") }}
                </button>
              </a>
            </template>

            <template v-if="tieneSinqro && !esSelfi">
              <!-- v-if="tieneSinqro" -->
              <button class="btn btn-success" @click="openModalImportador(true)">
                <!-- isMasakali = true  => nuevo camino -->
                <i class="fas fa-upload"></i> {{ $t("importarSinqro") }}
              </button>
              <button class="btn btn-primary" type="button" @click="deleteSinqro(false)" v-if="contadorEasterEgg >= 10">
                Del Sinq
              </button>
              <br />
              <span v-if="lastUploadedSinqro != 0" class="ml-1"><strong>Último envío</strong>:
                {{ lastUploadedSinqro | parseDateMinSlash }}</span>
            </template>

            <!--                        <a target="_blank" :href="'http://192.168.1.150/www.numier.com/pdf/index.php">-->
            <!--                            <button class="btn btn-info"><i class="fas fa-book-open"></i> Ver PDF</button>-->
            <!--                        </a>-->
          </div>
        </div>

        <div class="col-md-3 text-right" v-tooltip.top-center="$t('tolTipMostrarProductoDeBaja')">
          <div style="margin-top: 4px" class="form-group justify-content-center">
            <el-checkbox class="form-group" v-model="baja" @change="changeIsDeBaja()">
              <strong>{{ $t("buscarBaja") }}</strong>
            </el-checkbox>
          </div>
        </div>

        <div class="col-md-2">
          <div class="form-group" v-if="!esSelfi">
            <el-select class="select-default" size="large" v-model="idTipo" filterable @change="getProductosCarta()"
              :placeholder="'Selecciona tipo de los productos'">
              <el-option v-for="tipo in listTipoProducto" class="select-primary" :value="tipo.value" :label="tipo.label"
                :key="tipo.value">
              </el-option>
            </el-select>
          </div>
        </div>

        <div class="col-md-3 text-right">
          <div class="input-group">
            <input type="text" class="form-control" v-bind:placeholder="$t('buscar')" v-model="searchQuery"
              @keyup.enter.prevent="searchProductoCarta()" />
            <div class="input-group-append">
              <button class="btn btn-secondary" type="button" @click="searchProductoCarta">
                <i class="fa fa-search"></i>
              </button>
              <button class="btn btn-secondary" type="button" @click="removeProductoCarta()">
                <i class="fa fa-times"></i>
              </button>
            </div>
          </div>
        </div>

        <div class="col-md-12" v-for="cat in listProductosCarta">
          <p style="
              color: #1E22AA;
              margin: 10px 0px;
              font-size: 25px;
              font-family: 'Numier', 'Helvetica Neue', Arial;
              font-weight: bold;
            ">
            {{ cat.nombre }}
          </p>

          <div class="table-responsive">
            <table class="table table-bordered table-striped">
              <thead class="thead-dark">
                <tr>
                  <th v-if="!editarProductos">{{ $t("imagen") }}</th>
                  <th v-if="activeCarta && listCartas.length > 1">
                    {{ $t("carta") }}
                  </th>
                  <th v-if="!idTipo && !esSelfi">{{ $t("tipo") }}</th>
                  <th>{{ $t("nombre") }}</th>
                  <!-- <th>{{ $t("producto") }}</th> -->
                  <th>{{ $t("nombreEnTpv") }}</th>
                  <th>{{ $t("precioTarifa") }}</th>
                  <th>{{ $t("tarifa2") }}</th>
                  <th>{{ $t("tarifa3") }}</th>
                  <th>{{ $t("tarifa4") }}</th>
                  <th>{{ $t("categoria") }}</th>
                  <th class="text-center">{{ $t("acciones") }}</th>
                </tr>
              </thead>
              <tbody>
                <template v-for="obj in cat.productos">
                  <tr>
                    <td width="5%" v-if="!editarProductos">
                      <div>
                        <template v-if="obj.img">
                          <img @click="openModalEditar(obj)" width="100%" :src="obj.img + '?' + obj.updated" />
                        </template>

                        <template v-else>
                          <img @click="openModalEditar(obj)" width="100%"
                            src="https://www.numier.com/cartadigital/no-products.png" />
                        </template>
                      </div>
                    </td>

                    <!--No se usa-->
                    <td v-if="activeCarta && listCartas.length > 1">
                      <template v-if="!obj.modifier || !editarProductos">
                        <div>
                          {{ obj.nombreCarta }}
                        </div>
                      </template>
                      <template v-else>
                        <div>
                          <input type="text" v-model="obj.nombreCarta" class="form-control input-sm"
                            id="producto-name" />
                        </div>
                      </template>
                    </td>
                    <!--Hasta aqui-->

                    <td width="10%" v-if="!idTipo && !esSelfi">
                      <template v-if="!obj.modifier || !editarProductos">
                        <div class="px-2">
                          <template v-if="obj.tipoCarta === 'C'">{{
                $t("cartaASecas")
              }}</template>
                          <template v-else-if="obj.tipoCarta === 'P'">{{
                $t("pedido")
              }}</template>
                          <template v-else>{{ $t("cartaYPedido") }}</template>
                        </div>
                      </template>
                      <template v-else>
                        <div class="px-0">
                          <el-select class="select-default" size="large" v-model="obj.tipoCarta" filterable
                            :placeholder="$t('seleccionaTipo')">
                            <el-option v-for="filter in listTipoProductoCarta" class="select-primary"
                              :value="filter.value" :label="filter.label" :key="filter.value">
                            </el-option>
                          </el-select>
                        </div>
                      </template>
                    </td>

                    <td width="15%">
                      <div v-if="!obj.modifier || !editarProductos">
                        <span class="d-inline-block" v-bind:style="[
                !obj.noDisponible
                  ? {
                    'text-decoration': 'line-through',
                    'white-space': 'nowrap',
                    overflow: 'hidden',
                    'text-overflow': 'ellipsis',
                    'max-width': '200px',
                  }
                  : {
                    'white-space': 'nowrap',
                    overflow: 'hidden',
                    'text-overflow': 'ellipsis',
                    'max-width': '200px',
                  },
              ]" :title="obj.nameProducto">{{ obj.nameProducto }}</span>
                        <span style="color: red" v-if="obj.baja">
                          [{{ $t("BAJA") }}]
                        </span>
                      </div>
                      <div v-else>
                        <div>
                          <input type="text" v-model="obj.nameProducto" class="form-control input-sm"
                            id="producto-name" />
                        </div>
                      </div>
                    </td>

                    <td width="15%">
                      <div v-if="!obj.modifier || !editarProductos">
                        <span v-bind:style="[
                !obj.noDisponible
                  ? {
                    'text-decoration': 'line-through',
                    'white-space': 'nowrap',
                    overflow: 'hidden',
                    'text-overflow': 'ellipsis',
                    'max-width': '200px',
                  }
                  : {
                    'white-space': 'nowrap',
                    overflow: 'hidden',
                    'text-overflow': 'ellipsis',
                    'max-width': '200px',
                  },
              ]">{{ obj.nombreProductoRef }}</span>
                      </div>
                      <div v-else>
                        <div>
                          <!--<input
                            type="text"
                            v-model="obj.nombreProductoRef"
                            class="form-control input-sm"
                            id="producto-name"
                          /> -->
                          <el-select class="select-default" v-model="obj.idProducto" filterable remote reserve-keyword
                            :remote-method="searchProducto" :placeholder="$t('nombreDelProductoEnElTpv')">
                            <el-option class="select-primary" :value="'0'" :label="$t('productoCartaSinRelacionar')">
                            </el-option>
                            <el-option v-for="p in listProductos" :key="p.id" :label="p.name" :value="p.id">
                            </el-option>
                          </el-select>
                        </div>
                      </div>
                    </td>

                    <td width="8%">
                      <div v-if="!obj.modifier || !editarProductos">
                        <span v-bind:style="[
                !obj.noDisponible
                  ? { 'text-decoration': 'line-through' }
                  : {},
              ]">{{ obj.precioTarifa1 | currency }}</span>
                      </div>
                      <div v-else>
                        <vue-numeric currency="€" inputmode="decimal" type="text" currency-symbol-position="suffix"
                          :precision="2" v-model="obj.precioTarifa1" class="form-control input-sm" id="producto-name"
                          :disabled="obj.modifier &&
                (distinguirPrecios || distinguirPreciosCarta)
                " @keydown.native="$methods.evitarComasDecimales">
                        </vue-numeric>
                      </div>
                    </td>

                    <td width="8%">
                      <div v-if="!obj.modifier || !editarProductos">
                        <span v-bind:style="[
                !obj.noDisponible
                  ? { 'text-decoration': 'line-through' }
                  : {},
              ]">{{ obj.precioTarifa2 | currency }}</span>
                      </div>
                      <div v-else>
                        <vue-numeric currency="€" inputmode="decimal" type="text" currency-symbol-position="suffix"
                          :precision="2" v-model="obj.precioTarifa2" class="form-control input-sm" id="producto-name"
                          :disabled="obj.modifier &&
                (distinguirPrecios || distinguirPreciosCarta)
                " @keydown.native="$methods.evitarComasDecimales">
                        </vue-numeric>
                      </div>
                    </td>

                    <td width="8%">
                      <div v-if="!obj.modifier || !editarProductos">
                        <span v-bind:style="[
                !obj.noDisponible
                  ? { 'text-decoration': 'line-through' }
                  : {},
              ]">{{ obj.precioTarifa3 | currency }}</span>
                      </div>
                      <div v-else>
                        <vue-numeric currency="€" inputmode="decimal" type="text" currency-symbol-position="suffix"
                          :precision="2" v-model="obj.precioTarifa3" class="form-control input-sm" id="producto-name"
                          :disabled="obj.modifier &&
                (distinguirPrecios || distinguirPreciosCarta)
                " @keydown.native="$methods.evitarComasDecimales">
                        </vue-numeric>
                      </div>
                    </td>

                    <td width="8%">
                      <div v-if="!obj.modifier || !editarProductos">
                        <span v-bind:style="[
                !obj.noDisponible
                  ? { 'text-decoration': 'line-through' }
                  : {},
              ]">{{ obj.precioTarifa4 | currency }}</span>
                      </div>
                      <div v-else>
                        <vue-numeric currency="€" inputmode="decimal" type="text" currency-symbol-position="suffix"
                          :precision="2" v-model="obj.precioTarifa4" class="form-control input-sm" id="producto-name"
                          :disabled="obj.modifier &&
                (distinguirPrecios || distinguirPreciosCarta)
                " @keydown.native="$methods.evitarComasDecimales">
                        </vue-numeric>
                      </div>
                    </td>

                    <td width="10%" class="px-0">
                      <div v-if="!obj.modifier || !editarProductos">
                        <div v-if="obj.nombreCategoria" class="px-2">
                          {{ obj.nombreCategoria }}
                        </div>
                        <div v-else>{{ $t("sinCategoria") }}</div>
                      </div>
                      <div v-else class="px-0">
                        <div>
                          <el-select class="select-default" size="large" v-model="obj.idCategoria" filterable
                            :placeholder="$t('seleccionaUnaCategoria')">
                            <el-option v-for="filter in listCategories" class="select-primary" :value="filter.id"
                              :label="filter.nombre" :key="filter.id">
                            </el-option>
                          </el-select>
                        </div>
                      </div>
                    </td>
                    <!-- La función getPermisoCarta en la API realiza una consulta SELECT para verificar si, para un determinado idBusiness, existe una configuración
                    asociada al "control de idiomas" (por ejemplo, una entrada con idConfig=38). Si se encuentra dicha configuración, esta contiene un valor que indica
                    si está activa (1 para activado). Toda esta información se almacena en el objeto resultante que se devuelve al cliente.
                    
                    Aquí en el Front-End, se consulta la propiedad configcarta.controlIdiomas, la cual se alimenta de los datos devueltos por getPermisoCarta. Si esta 
                    propiedad es true, se muestra un ícono de globo (que representa la gestión de idiomas) y se habilita la funcionalidad para abrir el formulario de 
                    idiomas mediante el método abrirModalIdiomas(obj).-->
                    <td align="center" width="8%">
                      <template v-if="!editarProductos">

                        <!-- Acción 1: Traducir el producto a otros idiomas. Se muestra un ícono de globo si el control de idiomas está habilitado
                        en la configuración (configcarta.controlIdiomas). 
                          - class="btn btn-link btn-xs" le aporta un estilo, clases provienen de una biblioteca como Bootstrap.
                          - v-tooltip.top-center="$t('tolTipIdiomaProducto')": muestra un tooltip (mensaje flotante de ayuda) y $t(...): busca en el archivo de idiomas el texto asociado a'tolTipIdiomaProducto' 
                          - :key: Es una forma de enlazar dinámicamente una clave única al botón para ayudar a Vue a identificarlo.
                          - configcarta.toString(): Convierte el objeto configcarta (contiene configuraciones de la carta por ejemplo, si se permiten idiomas) en una cadena para usarlo como clave.
                          - @click="abrirModalIdiomas(obj)" al hacer click llama al método abrirModalIdiomas(obj) y le pasa como obj el producto que el usuario va a traducir. 
                          - v-if="configcarta.controlIdiomas" determina si este bloque debe mostrarse. Comprueba si la propiedad controlIdiomas dentro de configcarta es true.
                          -->
                        <div class="btn btn-link btn-xs" 
                          v-tooltip.top-center="$t('tolTipIdiomaProducto')"
                          :key="configcarta.toString()" 
                          @click="abrirModalIdiomas(obj)"
                          v-if="configcarta.controlIdiomas">
                          <i class="fas fa-globe-americas" style="color: #1f51ff"></i>
                        </div>

                        <!-- Acción 2: Editar el producto. Botón que redirige al formulario de edición del producto en la carta -->
                        <div class="btn btn-warning btn-link btn-xs">
                          <router-link :to="{
                              name: 'producto-carta',
                              params: {
                                idBusiness: idBusiness,
                                idCarta: idCarta,
                                idProducto: obj.id,
                              },
                            }">
                            <i style="color: orange" v-tooltip.top-center="$i18n.t('editar')"
                              class="fas fa-pencil-alt"></i>
                          </router-link>
                        </div>

                        <!-- Acción 3: Marcar como disponible o no disponible. Checkbox para cambiar el estado de disponibilidad del producto en la carta -->
                        <div class="btn btn-danger btn-link btn-xs"
                          v-tooltip.top-center="$t('tolTipDisponibleProducto')">
                          <el-checkbox @change="
                            changeNoDisponible(obj.id, obj.noDisponible)
                            " v-model="obj.noDisponible">
                            <template></template>
                            <strong>{{
                              obj.noDisponible
                                ? $t("disponible")
                                : $t("noDisponible")
                            }}  
                            </strong>
                          </el-checkbox>
                        </div>
                      </template>
                      <template v-else>
                        <template v-if="obj.modifier === false">
                          <button class="btn btn-primary" @click="obj.modifier = true">
                            <i v-tooltip.top-center="$i18n.t('editar')" class="fas fa-cog"></i>
                          </button>
                        </template>
                        <template v-else>
                          <button class="btn btn-success" @click="editProduct(obj)">
                            <i v-tooltip.top-center="$t('guardar')" class="far fa-save"></i>
                          </button>
                        </template>
                      </template>
                      <!--<div v-if="!obj.baja" @click="openModalBaja(obj.id)"-->
                      <!--class="btn btn-danger btn-link btn-xs">-->
                      <!--<i v-tooltip.top-center="'Dar de baja producto'" class="fas fa-trash-alt"></i>-->
                      <!--</div>-->
                      <!--<div v-else @click="openModalAlta(obj.id)"-->
                      <!--class="btn btn-success btn-link btn-xs">-->
                      <!--<i v-tooltip.top-center="'Dar de alta producto'" class="fas fa-undo"></i>-->
                      <!--</div>-->
                    </td>
                  </tr>
                  <tr v-if="obj.modifier &&
                (distinguirPrecios || distinguirPreciosCarta)
                ">
                    <td colspan="9" class="p-0">
                      <div class="table-responsive p-0 m-0">
                        <table class="table m-0">
                          <thead>
                            <tr class="bg-secondary">
                              <th colspan="5" class="text-light">
                                Modificar Precios
                              </th>
                            </tr>
                            <tr>
                              <th></th>
                              <th>Tarifa 1</th>
                              <th>Tarifa 2</th>
                              <th>Tarifa 3</th>
                              <th>Tarifa 4</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <th class="table-active">A recoger</th>
                              <td>
                                <vue-numeric currency="€" inputmode="decimal" type="text"
                                  currency-symbol-position="suffix" :precision="2" v-model="obj.precioTarifa1"
                                  class="form-control input-sm" id="producto-name" @keydown.native="
                $methods.evitarComasDecimales
                ">
                                </vue-numeric>
                              </td>
                              <td>
                                <vue-numeric currency="€" inputmode="decimal" type="text"
                                  currency-symbol-position="suffix" :precision="2" v-model="obj.precioTarifa2"
                                  class="form-control input-sm" id="producto-name" @keydown.native="
                $methods.evitarComasDecimales
                ">
                                </vue-numeric>
                              </td>
                              <td>
                                <vue-numeric currency="€" inputmode="decimal" type="text"
                                  currency-symbol-position="suffix" :precision="2" v-model="obj.precioTarifa3"
                                  class="form-control input-sm" id="producto-name" @keydown.native="
                $methods.evitarComasDecimales
                ">
                                </vue-numeric>
                              </td>
                              <td>
                                <vue-numeric currency="€" inputmode="decimal" type="text"
                                  currency-symbol-position="suffix" :precision="2" v-model="obj.precioTarifa4"
                                  class="form-control input-sm" id="producto-name" @keydown.native="
                $methods.evitarComasDecimales
                ">
                                </vue-numeric>
                              </td>
                            </tr>
                            <tr v-if="distinguirPrecios">
                              <th class="table-active">A domicilio</th>
                              <td>
                                <vue-numeric currency="€" inputmode="decimal" type="text"
                                  currency-symbol-position="suffix" :precision="2" v-model="obj.precioTarifa1_d"
                                  class="form-control input-sm" id="producto-name" @keydown.native="
                $methods.evitarComasDecimales
                ">
                                </vue-numeric>
                              </td>
                              <td>
                                <vue-numeric currency="€" inputmode="decimal" type="text"
                                  currency-symbol-position="suffix" :precision="2" v-model="obj.precioTarifa2_d"
                                  class="form-control input-sm" id="producto-name" @keydown.native="
                $methods.evitarComasDecimales
                ">
                                </vue-numeric>
                              </td>
                              <td>
                                <vue-numeric currency="€" inputmode="decimal" type="text"
                                  currency-symbol-position="suffix" :precision="2" v-model="obj.precioTarifa3_d"
                                  class="form-control input-sm" id="producto-name" @keydown.native="
                $methods.evitarComasDecimales
                ">
                                </vue-numeric>
                              </td>
                              <td>
                                <vue-numeric currency="€" inputmode="decimal" type="text"
                                  currency-symbol-position="suffix" :precision="2" v-model="obj.precioTarifa4_d"
                                  class="form-control input-sm" id="producto-name" @keydown.native="
                $methods.evitarComasDecimales
                ">
                                </vue-numeric>
                              </td>
                            </tr>
                            <tr v-if="distinguirPreciosCarta">
                              <th class="table-active">Carta Digital</th>
                              <td>
                                <vue-numeric currency="€" inputmode="decimal" type="text"
                                  currency-symbol-position="suffix" :precision="2" v-model="obj.precioTarifa1_c"
                                  class="form-control input-sm" id="producto-name" @keydown.native="
                $methods.evitarComasDecimales
                ">
                                </vue-numeric>
                              </td>
                              <td>
                                <vue-numeric currency="€" inputmode="decimal" type="text"
                                  currency-symbol-position="suffix" :precision="2" v-model="obj.precioTarifa2_c"
                                  class="form-control input-sm" id="producto-name" @keydown.native="
                $methods.evitarComasDecimales
                ">
                                </vue-numeric>
                              </td>
                              <td>
                                <vue-numeric currency="€" inputmode="decimal" type="text"
                                  currency-symbol-position="suffix" :precision="2" v-model="obj.precioTarifa3_c"
                                  class="form-control input-sm" id="producto-name" @keydown.native="
                $methods.evitarComasDecimales
                ">
                                </vue-numeric>
                              </td>
                              <td>
                                <vue-numeric currency="€" inputmode="decimal" type="text"
                                  currency-symbol-position="suffix" :precision="2" v-model="obj.precioTarifa4_c"
                                  class="form-control input-sm" id="producto-name" @keydown.native="
                $methods.evitarComasDecimales
                ">
                                </vue-numeric>
                              </td>
                            </tr>
                          </tbody>
                          <tfoot>
                            <tr class="bg-secondary p-0">
                              <th colspan="5" class="text-light"></th>
                            </tr>
                          </tfoot>
                        </table>
                      </div>
                    </td>
                    <!-- </tr>
                  <tr v-if="obj.modifier">
                    <th>A domicilio</th>
                    <td colspan="3"></td>
                    <td colspan="3"></td>
                    <td colspan="3"></td> -->
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </div>
      </template>
      <template v-if="!permiso && !isSelfi">
        <div class="col-md-12">
          <div class="alert alert-primary" align="center">
            <h3>
              <i class="fas fa-exclamation-circle"></i>
              {{ $t("esteNegocioNoTieneAccesoAEsteModulo") }}.
            </h3>

            <span>
              {{ $t("paraMasInformacionContacteConSu") }}
              <strong>{{ $t("distribuidor") }}</strong>.</span>
          </div>
        </div>
      </template>
       <template v-if="isSelfi">
                <div class="col-md-12">
                    <div class="alert alert-primary" align="center">
                    <h3>
                        <i class="fas fa-exclamation-circle"></i>
                        {{ $t("nosmudamos") }}
                    </h3>

                    <div style="margin-bottom: 2vh">                
                        {{$t("noscambiamosaselfi") }}
                        .</div>
                    
                    <!-- <a href="http://127.0.0.1:5173/validate-user" target="_blank">
                        {{ $t("paraContinuar") }}
                        <strong>Selfibar</strong>.
                    </a> -->

                    </div>
                        <button class="btn btn-primary" @click="redirectToSelfibar()">{{$t("irASelfibar")}}</button>

                    </div>
                </template>
    </div>

    <template>
      <modal name="modalSelectCategory" :adaptive="false" :scrollable="true" height="auto" :clickToClose="false"
        class="modalCategorySelect">
        <div>
          <div class="modal-header">
            <h4 style="margin: 0px">{{ $t("selectCategory") }}</h4>
          </div>

          <div class="modal-body">
            <!-- <input
            type="checkbox"
            id="checkSelectAllCategories"
            name="checkSelectAllCategories"
            v-model="checkSelectAllCategories"
            @click="selectAllCategories"
          />
          <label for="checkSelectAllCategories" class="checkSelectAll">{{
            $t("seleccionarTodos")
          }}</label> -->
            <el-checkbox :indeterminate="isIndeterminate" v-model="checkAllCategories" @change="handleCheckAllChange">{{
                $t("seleccionarTodos") }}</el-checkbox>
            <div style="margin: 15px 0"></div>

            <el-checkbox-group v-model="categoriesToImport" @change="handleCheckedCitiesChange">
              <el-checkbox v-for="category in categoriesNumierList" :label="category" :key="category.id" border
                style="margin: 2%; min-width: 29%">
                {{ category.nombre }}
              </el-checkbox>
            </el-checkbox-group>
          </div>
          <div class="modal-footer">
            <button class="btn btn-default" @click="$modal.hide('modalSelectCategory')">
              <i class="fa fa-times-circle"></i> {{ $t("cancelar") }}
            </button>
            <button class="btn btn-primary" @click="confirmarImportarSinqro">
              <!--  @click="replyProduct" -->
              <i class="fa fa-check-circle"></i>
              {{ $t("aceptar") }}
            </button>
          </div>
        </div>
      </modal>
    </template>

    <modal name="modalReply" :adaptive="true" :scrollable="true" height="auto" :clickToClose="false">
      <div>
        <div class="modal-header">
          <h4 style="margin: 0px">{{ $t("replicarTodosLosProductos") }}</h4>
        </div>
        <div class="modal-body">
          <input type="checkbox" id="checkSelectAll" name="checkSelectAll" v-model="checkSelectAll"
            @click="selectAll" />
          <label for="checkSelectAll" class="checkSelectAll">{{
                $t("seleccionarTodos")
              }}</label>

          <div v-for="business in listBusinessReply">
            <el-checkbox v-if="business.id != idBusiness" v-model="business.checked" border class="checkbox-element"
              style="width: 100%">
              {{ business.establishmentName }}
            </el-checkbox>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-default" @click="$modal.hide('modalReply')">
            <i class="fa fa-times-circle"></i> {{ $t("cancelar") }}
          </button>
          <button class="btn btn-primary" @click="modalConfirmation">
            <i class="fa fa-check-circle"></i>
            {{ $t("aceptar") }}
          </button>
        </div>
      </div>
    </modal>

    <modal :name="'editar-producto'" :adaptive="true" :scrollable="true" height="auto" :clickToClose="false">
      <div>
        <div class="modal-header">
          <h4 style="margin: 0px">{{ $t("editarImagen") }}</h4>
        </div>

        <div class="modal-body">
          <template v-if="productoEditar.img">
            <p>
              <strong>{{ $t("imagen") }}</strong>
              <span style="color: red">*</span>
              <i class="fas fa-pencil-alt text-warning" @click="productoEditar.img = ''"
                v-tooltip.top-center="$t('editarImagen')"></i>
            </p>
            <div style="width: 100%">
              <img width="100%" :src="productoEditar.img + '?' + productoEditar.updated" />
            </div>
          </template>
          <template v-else>
            <div class="form-group">
              <label><strong>{{ $t("imagen") }}</strong>
              </label>
              <input class="form-control" type="file" style="height: 100px" @change="onFileChange" />
              <br />
            </div>
          </template>
        </div>
        <div class="modal-footer">
          <button class="btn btn-default" @click="(img = ''), $modal.hide('editar-producto')">
            <i class="fa fa-times-circle"></i> {{ $t("cancelar") }}
          </button>
          <button class="btn btn-success" @click="editarImagen(productoEditar)">
            <i class="fa fa-check-circle"></i>
            {{ $t("guardar") }}
          </button>
        </div>
      </div>
    </modal>
    
    <modal :name="'anadir-idioma'" :adaptive="true" :scrollable="true" height="auto" :clickToClose="false">
      <div>
        <div class="modal-header">
          <h4 style="margin: 0px">
            {{ $t("traduccionDe") }} {{ productoEditar.nameProducto }}
          </h4>
        </div>

        <div class="modal-body">
          <label for="idioma">{{ $t("idioma") }}:</label>
          <br />
          <el-select class="select-default" size="large" v-model="selectedLang" @change="cambiarTraducciones"
            :placeholder="'Selecciona un idioma'">
            <el-option v-for="lang in langList" class="select-primary" :value="lang.idLang" :label="lang.name"
              :key="lang.idLang">
            </el-option>
          </el-select>
          <br />
          <div id="ingles" class="mt-3">
            <label for="traduccion">{{ $t("nombre") }}: </label>
            <input id="traduccion" class="form-control" type="text" v-model="traduccion" />
            <br />
            <label for="traduccion">{{ $t("descripcion") }}: </label>
            <input class="form-control" type="text" v-model="traduccionDesc" />
          </div>
        </div>

        <div class="modal-footer">
          <button class="btn btn-default" @click="(img = ''), $modal.hide('anadir-idioma')">
            <i class="fa fa-times-circle"></i> {{ $t("cancelar") }}
          </button>
          <button class="btn btn-success" @click="cambiarIdiomaAProducto(productoEditar)">
            <i class="fa fa-check-circle"></i>
            {{ $t("guardar") }}
          </button>
        </div>

      </div>
    </modal>
  </div>
</template>

<script>
import {
  DatePicker,
  Select,
  Option,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Button,
  Checkbox,
  CheckboxGroup,
} from "element-ui";
import { Loading } from "element-ui";
import swal from "sweetalert2";
import moment from "moment";

let p1,
  p2,
  p3,
  p4,
  p5 = null;
export default {
  name: "ConfiguracionCarta",

  created() {
    this.getBusiness();
    var image = new Image();
    image.src = this.url;
    this.alto = image.height;
    this.ancho = image.width;

    this.$store.dispatch("setNameRoute", "Productos carta");
    // GetCategorias la primera vez que carga
    this.getCategoriesNumier();
    this.checkIsSelfi();
  },
  data() {
    return {
      listCategories: [],
      listProductos: [],
      editarProductos: false,
      listTipoProducto: [
        {
          value: "",
          label: this.$t("todos"),
        },
        {
          value: "P",
          label: this.$t("pedidos"),
        },
        {
          value: "C",
          label: this.$t("cartaASecas"),
        },
      ],
      listTipoProductoCarta: [
        {
          value: "",
          label: this.$t("cartaYPedido"),
        },
        {
          value: "P",
          label: this.$t("pedidos"),
        },
        {
          value: "C",
          label: this.$t("cartaASecas"),
        },
      ],
      tituloDestacados: "",
      loading: null,
      idTipo: "",
      cacheImagen: 0,
      searchQuery: "",
      img: "",
      listProductosCarta: [],
      productoEditar: {},
      listBusinesses: [],
      idBusiness: 0,
      permiso: 1,
      nameRoute: "",
      logoNegocio: "",
      tokenServerSinqro: "",
      tokenUserSinqro: "",
      tieneSinqro: false,
      multiCartaSinqro: false,
      contadorEasterEgg: 0,
      descripcionCarta: "",
      tipoCarta: false,
      tipoPedido: false,
      activeCarta: false,
      listCartas: [],
      idCarta: 0,
      respuesta: false,
      preparadaCarta: false,

      alto: "",
      ancho: "",
      forCreate: false,
      lang: "en",
      selectedLang: 0,
      langList: [],
      traduccion: "",
      traduccionDesc: "",
      productTranslations: [],
      configcarta: {},

      //REPLY
      listBusinessReply: [],
      checkSelectAll: false,

      //Sinqro
      actualizarIds: 0,
      abierto: false,
      allRelsProd: [],
      relsDone: false,
      catsDone: false,
      noRecoger: true,
      noDomicilio: false,
      maxSelect: 10,
      url: "http://localhost:8001/static/img/Numier-Logo-Sin-Texto.png",
      base64: "",
      error: "",
      llamado: false,
      isMasakali: false,
      //Sinqro refactoring
      productsSinqroList: [],
      productsNumierList: [],
      prodSubprodCreateList: [],
      categoriesNumierList: [],
      productsOptionsSinqroList: [],
      productSubproductList: [],
      prodSubprodRelationList: [],
      agenciasSinqroList: [],
      ProdCategoriRelationList: [],
      cartasSqinro: [],
      sellingPoint: 0,
      ejecucionTestList: [
        {
          metodo: "met1",
          params: [false, false],
        },
        {
          metodo: "met2",
          params: [false, false],
        },
        {
          metodo: "met3",
          params: [false, false],
        },
        {
          metodo: "met4",
          params: [false, false],
        },
      ],

      //Sinqro categories
      checkAllCategories: false,
      categoriesToImport: [],
      isIndeterminate: true,
      extrasGratuitos: false,
      sinqroFinalizado: {
        noExistenProductosConSubproductos: false,
        noExistenProductosSinSubproductos: false,
        productosConSubproductos: false,
        productosSinSubproductos: false,
        ambosListos: 0,
      },
      tratandoSubproductos: false,
      baja: false,
      lastUploadedSinqro: 0,
      distinguirPrecios: false,
      distinguirPreciosCarta: false,
      esSelfi: false,
    };
  },
  watch: {
    idBusiness: function () {
      if (
        this.idBusiness == 2753 ||
        this.idBusiness == 4213 ||
        this.idBusiness == 4426 ||
        this.idBusiness == 4483 ||
        this.idBusiness == 4554 ||
        this.idBusiness == 4557 ||
        this.idBusiness == 4604 ||
        this.idBusiness == 3520 ||
        this.idBusiness == 5984
      ) {
        this.isMasakali = true;
      } else {
        this.isMasakali = false;
      }
    },
    "sinqroFinalizado.ambosListos": function () {
      this.comprobarFinalizacion();
    },
  },
  methods: {

    checkIsSelfi() {
      let vm = this;

      const esSelfiCookie = document.cookie
        .split("; ")
        .find((row) => row.startsWith("esSelfi="));

      // Verificar si la cookie existe antes de intentar acceder a su valor
      if (esSelfiCookie) {
        vm.esSelfi = esSelfiCookie.split("=")[1];
      } else {
        vm.esSelfi = false;
      }
    },


    editProduct(p) {
      for (let x = 0; x < this.listProductos.length; x++) {
        if (p.idProducto == this.listProductos[x].id) {
          p.nombreProductoRef = this.listProductos[x].name;
        }
      }

      let producto = {
        id: p.id,
        tipoCarta: p.tipoCarta,
        idProduct: p.idProducto,
        nameProducto: p.nameProducto,
        price1: p.precioTarifa1,
        price2: p.precioTarifa2,
        price3: p.precioTarifa3,
        price4: p.precioTarifa4,
        price1_d: p.precioTarifa1_d,
        price2_d: p.precioTarifa2_d,
        price3_d: p.precioTarifa3_d,
        price4_d: p.precioTarifa4_d,
        price1_c: p.precioTarifa1_c,
        price2_c: p.precioTarifa2_c,
        price3_c: p.precioTarifa3_c,
        price4_c: p.precioTarifa4_c,
        idCategoria: p.idCategoria,
      };

      let config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      let params = {
        product: producto,
        idBusiness: this.idBusiness,
        jwt: this.$store.getters.jwt,
      };

      let vm = this;

      this.axios
        .post(
          this.$store.getters.apiUrl + "delivery/editarProductoCartaById",
          params,
          config
        )
        .then(function (response) {
          if (response.data.response) {
            vm.$notify({
              message: vm.$t("productosEditadosCorrectamente"),
              icon: "nc-icon nc-check-2",
              timeout: 2000,
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "success",
            });

            // vm.getProductosCarta();
            p.modifier = false;
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        });
    },

    getCategoriesCarta() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.$store.dispatch("setIdBusiness", this.idBusiness);
      this.axios
        .get(
          this.$store.getters.apiUrl + "delivery/getCategoriesCartaSinPadres",
          config
        )
        .then(function (response) {
          if (response.data.response) {
            vm.listCategories = [];

            for (let i = 0; i < response.data.result.length; i++) {
              let categoryname = {
                nombre: response.data.result[i].nombre,
                id: String(response.data.result[i].id),
              };

              vm.listCategories.push(categoryname);
            }
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    // searchProducto(query) {
    //   if (query !== "") {
    //     const controller = "searchProductsTpv";
    //     var config = {
    //       params: {
    //         idBusiness: this.idBusiness,
    //         jwt: this.$store.getters.jwt,
    //         query: query,
    //       },
    //       headers: { Authorization: "Bearer " + this.$store.getters.jwt },
    //     };
    //   }
    // },

    searchProducto(query) {
      let busqueda = query;
      if (!this.listProductos.length > 0) {
        busqueda = "";
      }
      // if (query !== "") {
      const controller = "searchProductsTpv";
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
          query: busqueda,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "delivery/" + controller, config)
        .then(function (response) {
          if (response.data.response) {
            vm.listProductos = response.data.result.products;
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function (error) {
          console.log(error);
        });
      // }
    },

    /**************************************************************************/

    /**
     * numiertpv --> idtpv=3308 , idbussines = 4
     * edu --> idtpv=15, idbussines =
     * coli --> idtpv=4475 ,   idbussines = 10
     * laloca --> idtpv=2942 ,
     *
     **/

    /************************/
    /** Refactoring Sinqro */

    comprobarFinalizacion() {
      if (this.sinqroFinalizado.noExistenProductosConSubproductos) {
        if (
          this.sinqroFinalizado.productosSinSubproductos &&
          this.sinqroFinalizado.ambosListos == 1
        ) {
          this.prepararCarta();
        }
      } else if (this.sinqroFinalizado.noExistenProductosSinSubproductos) {
        if (
          this.sinqroFinalizado.productosConSubproductos &&
          this.sinqroFinalizado.ambosListos == 1
        ) {
          this.prepararCarta();
        }
      } else {
        if (
          this.sinqroFinalizado.productosConSubproductos &&
          this.sinqroFinalizado.productosSinSubproductos &&
          this.sinqroFinalizado.ambosListos >= 2
        ) {
          this.prepararCarta();
        }
      }
    },
    checkSinqroConfig() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
          numConfig: 82,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.$store.dispatch("setIdBusiness", this.idBusiness);
      this.axios
        .get(this.$store.getters.apiUrl + "general/getConfigTpv", config)
        .then(function (response) {
          if (response.data.response) {
            vm.extrasGratuitos = true;
          } else {
            vm.extrasGratuitos = false;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    confirmarImportarSinqro() {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      var params = {
        idBusiness: this.idBusiness,
        jwt: this.$store.getters.jwt,
        categoriesList: this.categoriesToImport,
        idCarta: this.idCarta,
      };

      var vm = this;
      vm.axios
        .post(
          vm.$store.getters.apiUrl + "general/insertLogsGeneral",
          params,
          config
        )
        .then(function (response) { })
        .catch(function (error) {
          console.log(error);
          vm.loading.close();
        });

      this.$modal.hide("modalSelectCategory");

      this.loading = Loading.service({
        text: this.$t("laImportacionTardara"),
      });

      var vm = this;
      var config = {
        headers: {
          "x-api-server-access-token": this.tokenServerSinqro,
          "x-api-user-access-token": this.tokenUserSinqro,
        },
      };

      this.axios
        .post(
          "https://api.sinqro.com/pos-app/v1/sellingPoints/" +
          vm.sellingPoint +
          "/truncate",
          "",
          config
        )
        .then(function (response) {
          vm.actualizarIdNumierToCero();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    handleCheckAllChange(val) {
      this.categoriesToImport = val ? this.categoriesNumierList : [];
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAllCategories =
        checkedCount === this.categoriesNumierList.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.categoriesNumierList.length;
    },

    cancelarEdicion() {
      this.listProductosCarta.forEach(function (x) {
        x.productos.forEach(function (p) {
          p.modifier = false;
        });
      });
      this.editarProductos = false;
      this.getProductosCarta();
    },

    getProductsSinqro() {
      this.productsSinqroList = [];
      var vm = this;
      var config = {
        headers: {
          "x-api-server-access-token": vm.tokenServerSinqro,
          "x-api-user-access-token": vm.tokenUserSinqro,
        },
      };
      p1 = this.axios
        .get(
          "https://api.sinqro.com/pos-app/v1/sellingPoints/" +
          vm.sellingPoint +
          "/products",
          config
        )
        .then(function (responseProdSinq) {
          vm.productsSinqroList = responseProdSinq.data;
        })
        .catch(function (error) {
          console.log(error);

          vm.loading.close();

          swal({
            title: "¡Lo sentimos!",
            text:
              "Se ha producido un error en Sinqro. Intente realizar la importación nuevamente.",
            confirmButtonClass: "btn btn-info btn-fill",
            type: "error",
          });
        });
    },

    getProductOptionsSinqro() {
      var vm = this;
      var config = {
        headers: {
          "x-api-server-access-token": vm.tokenServerSinqro,
          "x-api-user-access-token": vm.tokenUserSinqro,
        },
      };

      p2 = this.axios
        .get(
          "https://api.sinqro.com/pos-app/v1/sellingPoints/" +
          vm.sellingPoint +
          "/productOptionsCategories",
          config
        )
        .then(function (responseCatSinq) {
          vm.productsOptionsSinqroList = responseCatSinq.data;
        })
        .catch(function (error) {
          vm.loading.close();
          console.log(error);
        });
    },

    getCategoriesNumier() {
      var vm = this;
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      p3 = this.axios
        .get(this.$store.getters.apiUrl + "delivery/getCategoriesCarta", config)
        .then(function (responseProds) {
          vm.categoriesNumierList = responseProds.data.result;
          vm.catsDone = true;
        })
        .catch(function (error) {
          vm.loading.close();
          console.log(error);
        });
    },

    getAgenciaSinqro() {
      var vm = this;
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
          idCarta: this.idCarta,
          idTipo: "P",
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      p4 = this.axios
        .get(this.$store.getters.apiUrl + "delivery/getAgenciasSinqro", config)
        .then(function (responseAgencias) {
          vm.agenciasSinqroList = responseAgencias.data.result;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    relacionarProductosYCategorias(finalizado) {
      var catProdList = [];
      var listaIdProd = [];
      var max = 0;
      var listaProdNum = JSON.parse(JSON.stringify(this.productsNumierList));

      listaProdNum.forEach(function (prodNum, i) {
        if (prodNum.max_extra > max) {
          max = prodNum.max_extra;
        }

        var nextId = i + 1;
        var idCategoriaSelected = prodNum.idCategoria;
        listaIdProd.push(prodNum.id);
        if (
          nextId == listaProdNum.length ||
          idCategoriaSelected != listaProdNum[nextId].idCategoria
        ) {
          var jsonRel = {
            idCategoria: idCategoriaSelected,
            productsIdList: listaIdProd,
          };

          catProdList.push(jsonRel);

          listaIdProd = [];
        }
      });

      this.maxSelect = max;
      this.ProdCategoriRelationList = catProdList;
      this.relsDone = true;

      if (finalizado && this.preparadaCarta == false) {
        if (this.extrasGratuitos) {
          this.sinqroFinalizado.ambosListos =
            this.sinqroFinalizado.ambosListos < 2
              ? this.sinqroFinalizado.ambosListos + 1
              : this.sinqroFinalizado.ambosListos;
        } else {
          this.prepararCarta();
        }
      }
    },

    getProductoNumier(finalizado) {
      this.relsDone = false;
      this.productsNumierList = [];

      let idCategorias = [];

      idCategorias = this.categoriesToImport.map((a) => {
        return a.id;
      });

      let vm = this;
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
          idCarta: this.idCarta,
          idTipo: "P",
          categoriesList: idCategorias,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      this.axios
        .get(
          this.$store.getters.apiUrl + "products/getProductCartaSinqro",
          config
        )
        .then(function (responseProds) {
          if (responseProds.data.result) {
            vm.productsNumierList = responseProds.data.result.filter(
              (prod) => prod.noMostrarSuelto == 0 && prod.isMenu == 0
            );
          }

          /*const listaSinMenus = responseProds.data.result.filter(
            (prod) => prod.noMostrarSuelto == 0 && prod.isMenu == 0
          );*/

          if (vm.productsNumierList.length == 0) {
            vm.loading.close();

            vm.openModalErrorSelectCategories();
          } else {
            vm.relacionarProductosYCategorias(finalizado);

            if (vm.tratandoSubproductos == false) {
              vm.getSubProductosNumier();
            }
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    getSubProductosNumier() {
      this.tratandoSubproductos = true;
      var subProd = [];
      this.productSubproductList = [];

      if (!this.preparadaCarta) {
        this.getProductsSinqro();

        this.loading.close();
        this.loading = Loading.service({
          text: this.$t("estamosEnEllo"),
        });

        Promise.all([p1]).then(() => {
          this.productsNumierList.forEach((prodNum) => {
            var config = {
              params: {
                idBusiness: this.idBusiness,
                jwt: this.$store.getters.jwt,
                idProduct: prodNum.id,
              },
              headers: { Authorization: "Bearer " + this.$store.getters.jwt },
            };
            var vm = this;
            this.axios
              .get(
                this.$store.getters.apiUrl +
                "/products/getProductSubproductCarta",
                config
              )
              .then(function (responseSubproduct) {
                subProd = responseSubproduct.data;
                var prodSubProd = {
                  producto: prodNum,
                  subProd: subProd,
                };
                vm.productSubproductList.push(prodSubProd);
                //Comprobacion de si (prodNum) es el ultimo producto de (productsNumierList)

                if (
                  vm.productsNumierList.length ==
                  vm.productSubproductList.length
                ) {
                  vm.filtrarByCreado();
                }
              })
              .catch(function (error) {
                console.log(error);
                vm.loading.close();
              });
          });
        });
      }
    },
    getProductAgenciaSinqro() {
      var vm = this;
      var prodListConSubs = JSON.parse(
        JSON.stringify(this.productSubproductList)
      );
      var prodAgenciaList = [];
      var asinq = [];
      prodListConSubs.forEach((prod) => {
        var config = {
          params: {
            idProduct: prod.producto.id,
            jwt: this.$store.getters.jwt,
          },
          headers: { Authorization: "Bearer " + this.$store.getters.jwt },
        };
        this.axios
          .get(
            this.$store.getters.apiUrl +
            "products/getProductsCartaAgenciaSinqro",
            config
          )
          .then(function (responseProds) {
            responseProds.data.result.forEach((prodAgencia) => {
              prodAgencia.nameProducto = prod.producto.nameProducto;
              prodAgencia.imgBase64 = prod.producto.imgBase64;
              prodAgencia.descripcion = prod.producto.descripcion;
              prodAgencia.idCategoria = prod.producto.idCategoria;
              prodAgencia.max_extra = prod.producto.max_extra;
              prodAgencia.baja = prod.producto.baja;

              var prodSubProd = {
                producto: prodAgencia,
                subProd: prod.subProd,
              };
              if (prodSubProd.producto.noDisponible == "0") {
                prodAgenciaList.push(prodSubProd);
              }
            });
            asinq.push(responseProds);
            if (asinq.length == prodListConSubs.length) {
              vm.tratamientoConcatArray(prodAgenciaList);
            }
          })
          .catch(function (error) {
            console.log(error);
            vm.loading.close();
          });
      });
    },
    tratamientoConcatArray(prodAgencia) {
      function compareByIdAgencia(a, b) {
        if (a.producto.idAgenciaSinqro < b.producto.idAgenciaSinqro) {
          return -1;
        }
        if (a.producto.idAgenciaSinqro > b.producto.idAgenciaSinqro) {
          return 1;
        }
        // a debe ser igual b
        return 0;
      }

      prodAgencia.sort(compareByIdAgencia);

      var prodSubProdFull = this.productSubproductList.concat(prodAgencia);
      this.productSubproductList = prodSubProdFull;
      this.productsNumierList = prodSubProdFull;
      this.prodSubprodRelationList = prodSubProdFull;

      this.relsDone = true;

      if (!this.preparadaCarta) {
        this.filtrarByCreado();
      }
    },

    filtrarByCreado() {
      var listProdToCreate = [];
      // Cuidado si lista productsSinqroList viene vacia
      if (this.productsSinqroList.length == 0) {
        listProdToCreate = this.productSubproductList;
      } else {
        this.productSubproductList.forEach((element) => {
          var prodSel = element.producto;
          if (prodSel.idSinqro == 0 && prodSel.importadoSinqro == 0) {
            listProdToCreate.push(element);
          }
        });
      }

      this.filtrarBySubProductos(listProdToCreate);
    },

    filtrarBySubProductos(listProdToCreate) {
      var vm = this;
      var config = {
        headers: {
          "x-api-server-access-token": vm.tokenServerSinqro,
          "x-api-user-access-token": vm.tokenUserSinqro,
        },
      };
      // Comprobar si tiene subproductos
      var prodSinSubListC = listProdToCreate.filter((prod) => {
        let variable = false;

        if (prod.subProd[0] == null) {
          variable = true;
        } else {
          if (prod.subProd[0].subProdName == null) {
            variable = true;
          }
        }

        return variable;
      });

      var prodConSubListC = listProdToCreate.filter((prod) => {
        let variable = false;

        if (prod.subProd[0] != null) {
          if (prod.subProd[0].subProdName != null) {
            variable = true;
          }
        }

        return variable;
      });

      this.prodSubprodCreateList = prodConSubListC;

      /**
       *
       * prodSinSubListC --> lista preparada para crear productos sin subproductos
       * prodConSubListC --> lista preparada para crear productos con subproductos
       * prodSinSubListE --> lista preparada para editar productos sin subproductos
       * prodConSubListE --> lista preparada para editar productos con subproductos
       *
       */

      // Si las listas no estan vacias, empezamos el tratamiento.
      if (prodConSubListC.length != 0) {
        this.agruparProductosConProductOptions(prodConSubListC);
      } else {
        this.sinqroFinalizado.noExistenProductosConSubproductos = true;
      }

      // Comprobamos si las lista estan vacias dentro del propio metodo.

      if (!this.sinqroFinalizado.productosSinSubproductos) {
        this.crearProductoSinSubSinqro([], prodSinSubListC);
      }
    },

    crearProductoSinSubSinqro(categoryList, productosListC) {
      var relationList = [];
      var vm = this;
      var vacias = true;
      var metodo = "";
      if (productosListC.length != 0) {
        metodo = "met1";
        vm.ejecucionTestList.forEach((element) => {
          if (element.metodo == metodo) {
            element.params = [true, false];
          }
        });
        vacias = false;
        relationList = [];
        productosListC.forEach(function (element, i) {
          var nextId = i + 1;
          var prodSelected = element.producto;
          var variantes = [];

          if (prodSelected.imgBase64 == "") {
            var data = "";
          } else {
            //var data = "data:image/jpeg;base64," + prodSelected.imgBase64;
            var data = prodSelected.imgBase64;
          }

          if (vm.isMasakali) {
            if (prodSelected.price2_d > 0 && prodSelected.namePrice2_d != "") {
              var variante = {
                name: prodSelected.namePrice2_d,
                externalId: prodSelected.id,
                image: data,
                /*image: {
                  filename:
                    prodSelected.nameProducto.trim() + "-variant-foto.jpeg",
                  data: data,
                },*/
                shortDescription: prodSelected.descripcion,
                price: {
                  amount: prodSelected.price2_d,
                  vatValue: 10.0,
                },
                id: null,
              };

              variantes.push(variante);
            }

            if (prodSelected.price3_d > 0 && prodSelected.namePrice3_d != "") {
              var variante = {
                name: prodSelected.namePrice3_d,
                externalId: prodSelected.id,
                image: data,
                /*image: {
                  filename:
                    prodSelected.nameProducto.trim() + "-variant-foto.jpeg",
                  data: data,
                },*/
                shortDescription: prodSelected.descripcion,
                price: {
                  amount: prodSelected.price3_d,
                  vatValue: 10.0,
                },
                id: null,
              };

              variantes.push(variante);
            }

            if (prodSelected.price4_d > 0 && prodSelected.namePrice4_d != "") {
              var variante = {
                name: prodSelected.namePrice4_d,
                externalId: prodSelected.id,
                image: data,
                /*image: {
                  filename:
                    prodSelected.nameProducto.trim() + "-variant-foto.jpeg",
                  data: data,
                },*/
                shortDescription: prodSelected.descripcion,
                price: {
                  amount: prodSelected.price4_d,
                  vatValue: 10.0,
                },
                id: null,
              };

              variantes.push(variante);
            }
          } else {
            if (prodSelected.price2 > 0 && prodSelected.namePrice2 != "") {
              var variante = {
                name: prodSelected.namePrice2,
                externalId: prodSelected.id,
                image: data,
                /*image: {
                  filename:
                    prodSelected.nameProducto.trim() + "-variant-foto.jpeg",
                  data: data,
                },*/
                shortDescription: prodSelected.descripcion,
                price: {
                  amount: prodSelected.price2,
                  vatValue: 10.0,
                },
                id: null,
              };

              variantes.push(variante);
            }

            if (prodSelected.price3 > 0 && prodSelected.namePrice3 != "") {
              var variante = {
                name: prodSelected.namePrice3,
                externalId: prodSelected.id,
                image: data,
                /*image: {
                  filename:
                    prodSelected.nameProducto.trim() + "-variant-foto.jpeg",
                  data: data,
                },*/
                shortDescription: prodSelected.descripcion,
                price: {
                  amount: prodSelected.price3,
                  vatValue: 10.0,
                },
                id: null,
              };

              variantes.push(variante);
            }

            if (prodSelected.price4 > 0 && prodSelected.namePrice4 != "") {
              var variante = {
                name: prodSelected.namePrice4,
                externalId: prodSelected.id,
                image: data,
                /*image: {
                  filename:
                    prodSelected.nameProducto.trim() + "-variant-foto.jpeg",
                  data: data,
                },*/
                shortDescription: prodSelected.descripcion,
                price: {
                  amount: prodSelected.price4,
                  vatValue: 10.0,
                },
                id: null,
              };

              variantes.push(variante);
            }
          }

          var config = {
            headers: {
              "x-api-server-access-token": vm.tokenServerSinqro,
              "x-api-user-access-token": vm.tokenUserSinqro,
            },
          };

          if (prodSelected == undefined) {
          } else {
            if (prodSelected.hasOwnProperty("idAgenciaSinqro")) {
              var idAgenciaSinqro = prodSelected.idAgenciaSinqro;
            } else {
              var idAgenciaSinqro = 0;
            }

            let precio1 = 0;

            if (vm.isMasakali) {
              precio1 = prodSelected.price1_d;
            } else {
              precio1 = prodSelected.price1;
            }

            var productoInputData = {
              name: prodSelected.nameProducto,
              externalId: prodSelected.id,
              price: {
                amount: precio1,
                vatValue: "10",
              },
              inMenuPrice: {
                amount: precio1,
                vatValue: "10",
              },
              shortDescription: prodSelected.descripcion,
              description: prodSelected.descripcion,
              image: data,
              /*image: {
                filename: prodSelected.nameProducto.trim() + "-foto.jpeg",
                data: data,
              },*/
              public: prodSelected.baja == 1 ? false : true,
              featured: false,
              isAvailable: prodSelected.noDisponible == 1 ? false : true,
              addProductOptionsToVariants: true,
              productVariants: variantes,
              tags: [],
              productOptionsIds: categoryList,
            };

            vm.productsSinqroList.push(productoInputData);
            vm.axios
              .post(
                "https://api.sinqro.com/pos-app/v1/sellingPoints/" +
                vm.sellingPoint +
                "/products",
                productoInputData,
                config
              )
              .then(function (response) {
                var idProdIdSinq = {
                  productId: response.data.externalId,
                  productIdSinqro: response.data.id,
                  idAgenciaSinqro: idAgenciaSinqro,
                };

                relationList.push(idProdIdSinq);
                if (productosListC.length == relationList.length) {
                  vm.sinqroFinalizado.productosSinSubproductos = true;

                  // Si no hay productos con subproductos para crear y las categorias de
                  if (
                    vm.prodSubprodCreateList.length == 0 &&
                    vm.productsOptionsSinqroList.length == 0
                  ) {
                    vm.crearCategorySinqro([]);
                  }

                  vm.ejecucionTestList.forEach((element) => {
                    if (element.metodo == metodo) {
                      element.params = [true, true];
                    }
                  });

                  setTimeout(() => {
                    vm.actualizarIdSinqro(relationList); // XP
                    vm.allRelsProd = vm.allRelsProd.concat(relationList);

                    vm.actualizarIds += 1;
                  }, 1500);
                }
              })
              .catch(function (error) {
                vm.loading.close();

                swal({
                  title: "¡Lo sentimos!",
                  text:
                    "Se ha producido un error en Sinqro. Intente realizar la importación nuevamente.",
                  confirmButtonClass: "btn btn-info btn-fill",
                  type: "error",
                });
              });
          }
        });
      } else {
        this.sinqroFinalizado.noExistenProductosSinSubproductos = true;
      }

      // En este punto habria que hacer antes de la edicion, una comparacion de subproductos
      // para poder sacar los ids que se desechan y borrarlos.
      // Si las listas vienen vacias.
      if (vacias) {
        vm.loading.close();
        vm.loading = Loading.service({
          text: vm.$t("generandoCarta"),
        });
        setTimeout(() => {
          this.prepararCarta();
        }, 10000);
      }
    },

    agruparProductosConProductOptions(prodConSubList) {
      var vm = this;
      var nombreTipo = null;
      var subproductos = [];
      var prodCatList = [];

      prodConSubList.forEach((element) => {
        // element.producto --> producto
        var prodSubProdCategoryJson = {
          producto: element.producto,
          categoriesWithSub: [],
        };
        var listaSub = element.subProd;
        listaSub.forEach(function (elementSub, i) {
          var divisiones = elementSub.subProdName.split(" ", 1);

          if (elementSub.tipo == "B" && divisiones != "Sin") {
            elementSub.subProdName = "Sin " + elementSub.subProdName;
          }
          var nextIndex = i + 1;
          // elementSub --> subproductos de element.producto
          if (
            listaSub[nextIndex] == undefined ||
            listaSub[i].tipo != listaSub[nextIndex].tipo
          ) {
            // Entra cuando el tipo actual de element.subprod es diferente al siquiente elemento ó cuando no hay mas elementos.
            // Lo que indica que el producto es el mismo, pero la categoria y los subproductos cambian.
            if (elementSub.tipo == "E") {
              nombreTipo = "(EXTRAS) Añade lo que quieras";
            } else if (elementSub.tipo == "O") {
              nombreTipo = "(Opcionales) Elige uno";
            } else if (elementSub.tipo == "B") {
              nombreTipo = "(BASES) ¿Quieres quitar algo?";
            } else {
              nombreTipo = "Categoria varios";
            }
            subproductos.push(elementSub);
            var catWithSub = {
              id: null,
              name: nombreTipo,
              shortDescription: "",
              position: 1,
              maxSelection: vm.maxSelect,
              minSelection: 0,
              maxSameOptionSelection: vm.maxSelect,
              selectionLabel: "Max. 10",
              productOptions: subproductos,
            };

            prodSubProdCategoryJson.categoriesWithSub.push(catWithSub);
            subproductos = [];
          } else {
            subproductos.push(elementSub);
          }
        });
        prodCatList.push(prodSubProdCategoryJson);
      });

      /*
       * Lista de productos categorias y subproductos agrupada de la siguiente forma:
       *
       * prodCatList = [
       *   { producto: producto1,
       *     categoriesWithSub: [
       *       0-> base: [sub1, sub2, sub3],
       *       1-> extra: [sub1, sub2]
       *     ]
       *   },
       *   { producto: producto2,
       *     categoriesWithSub: [
       *       0-> base: [sub1, sub2],
       *       1-> extra: [sub1, sub2, sub3],
       *       2-> opcional: [sub1]
       *     ]
       *   }, etc, etc, etc]
       *
       */
      if (prodCatList[0].producto.idSinqro == 0) {
        // Preparar categorias y productOptions para crear
        this.prepararProductOptionsToCreate(prodCatList);
      }
    },

    comprobarEjecuciones() {
      var done = true;
      this.ejecucionTestList.forEach((element) => {
        if (element.params[0] && !element.params[1]) {
          done = false;
        }
        // else if (!element.params[0] && !element.params[1]) {
        //   done = false;
        // } else if (!element.params[0] && element.params[1]) {
        //   done = false;
        // }
      });

      return done;
    },

    prepararProductOptionsToCreate(prodCatList) {
      /**
       * Recorrer todos los productos y sus opciones, crear jsones para que cada categoria solo se cree una unica vez.
       * Hay que guardar el idRef de cada subproducto y dejarlo enlazado con el producto, cuando se vaya a crear el producto,
       * se hace la peticion de todas las categorias de sinqro y se compara el idExterno con el id que tiene de referencia el producto
       * entoces se crea el producto con los ids de sinqro idExterno como relacion.
       */
      var prodOptionB = [];
      var prodOptionE = [];
      var prodOptionO = [];
      var prodOptionO2 = [];
      var prodOptionO3 = [];
      var dosExtrasGratis = false;
      var tresExtrasGratis = false;
      // Producto relacionado con subproductos por idRef
      var relationProductoJsonList = [];
      var categoriesToCreateList = [];

      var categoryJsonB = {
        name: "(BASES) ¿Quieres quitar algo?",
        externalId: null,
        shortDescription: "Base",
        minOptions: 0,
        maxOptions: 0,
        maxSameOptionSelection: 0,
        position: 1,
        productOptions: prodOptionB,
      };
      var categoryJsonE = {
        name: "(EXTRAS) Añade lo que quieras",
        externalId: null,
        shortDescription: "Extra",
        minOptions: 0,
        maxOptions: 0,
        maxSameOptionSelection: 0,
        position: 1,
        productOptions: prodOptionE,
      };
      var categoryJsonO = {
        name: "(Opcionales) Elige alguna de las opciones",
        externalId: null,
        shortDescription: "Optional",
        minOptions: 0,
        maxOptions: 1,
        maxSameOptionSelection: 1,
        position: 1,
        productOptions: prodOptionO,
      };
      var categoryJsonO2 = {
        name: "(Opcionales) Elige alguna de las opciones",
        externalId: null,
        shortDescription: "Optional",
        minOptions: 0,
        maxOptions: 1,
        maxSameOptionSelection: 1,
        position: 1,
        productOptions: prodOptionO2,
      };
      var categoryJsonO3 = {
        name: "(Opcionales) Elige alguna de las opciones",
        externalId: null,
        shortDescription: "Optional",
        minOptions: 0,
        maxOptions: 1,
        maxSameOptionSelection: 1,
        position: 1,
        productOptions: prodOptionO3,
      };
      let vm = this;

      prodCatList.forEach((element) => {
        //element.categoriesWithSub --> array de categorias con subproductos
        //element.producto --> producto para guardar
        //element.categoriesWithSub.productOptions.idRef --> id para relacionar producto (¿Y si hay el mismo subproducto en diferente category?)
        //SETEO EL MAXIMO DE EXTRAS
        categoryJsonE.maxOptions = 0; //parseInt(element.producto.max_extras);

        var relaciones = [];
        var jsonRelacion = {
          producto: element.producto,
          idRefList: relaciones,
        };
        var listaCatSubProd = element.categoriesWithSub;

        listaCatSubProd.forEach((catSubProdElem) => {
          catSubProdElem.productOptions.forEach((elementSub) => {
            var optionsJson = {
              name: elementSub.subProdName,
              externalId: elementSub.idRef,
              shortDescription: "",
              price: {
                amount: elementSub.variacion_precio,
                vatValue: 10.0,
              },
              position: 1,
              isAvailable: true,
            };

            if (elementSub.tipo == "B") {
              prodOptionB.push(optionsJson);
            } else if (elementSub.tipo == "E") {
              prodOptionE.push(optionsJson);

              if (
                vm.extrasGratuitos &&
                parseInt(element.producto.min_extras) > 0
              ) {
                //EN CASO DE QUERER EXTRAS GRATIS LOS HAGO PASAR POR OPCIONES Y EL NUMERO DE EXTRAS GRATIS ES EL MIN EXTRAS
                categoryJsonO.maxOptions = 1; //parseInt(element.producto.min_extras);

                var optionsJsonO = {
                  name: elementSub.subProdName,
                  externalId: elementSub.idRef,
                  shortDescription: "",
                  price: {
                    amount: 0,
                    vatValue: 10.0,
                  },
                  position: 1,
                  isAvailable: true,
                };

                prodOptionO.push(optionsJsonO);

                if (
                  vm.extrasGratuitos &&
                  parseInt(element.producto.min_extras) == 2
                ) {
                  dosExtrasGratis = true;

                  var optionsJsonO2 = {
                    name: elementSub.subProdName,
                    externalId: elementSub.idRef,
                    shortDescription: "",
                    price: {
                      amount: 0,
                      vatValue: 10.0,
                    },
                    position: 1,
                    isAvailable: true,
                  };

                  prodOptionO2.push(optionsJsonO2);
                }

                if (
                  vm.extrasGratuitos &&
                  parseInt(element.producto.min_extras) == 3
                ) {
                  tresExtrasGratis = true;

                  var optionsJsonO3 = {
                    name: elementSub.subProdName,
                    externalId: elementSub.idRef,
                    shortDescription: "",
                    price: {
                      amount: 0,
                      vatValue: 10.0,
                    },
                    position: 1,
                    isAvailable: true,
                  };

                  prodOptionO3.push(optionsJsonO3);
                }
              }
            } else if (elementSub.tipo == "O") {
              prodOptionO.push(optionsJson);
            } else {
            }

            relaciones.push(elementSub.idRef);
          });
        });
        relationProductoJsonList.push(jsonRelacion);
      });

      categoriesToCreateList.push(categoryJsonO);

      if (dosExtrasGratis) {
        categoriesToCreateList.push(categoryJsonO2);
      }

      if (tresExtrasGratis) {
        categoriesToCreateList.push(categoryJsonO3);
      }

      categoriesToCreateList.push(categoryJsonB);
      categoriesToCreateList.push(categoryJsonE);

      this.prodSubprodRelationList = relationProductoJsonList;

      if (this.productsOptionsSinqroList.length == 0) {
        this.crearCategorySinqro(categoriesToCreateList);
        this.loading.close();
        this.loading = Loading.service({
          text: this.$t("yaFaltaPoco"),
        });
      } else {
        //Este caso es con categorias ya existentes.
        setTimeout(() => {
          this.prepareProdOptAfterFirstImport(categoriesToCreateList);
        }, 2000);
      }
    },

    relacionarProductosBis(prerelations, categoryEditedList) {
      // Comparar la lista de productsOptions (los externalId) de cada element de categoryEditedList con los ids de prerelations
      // En prerelations estan las relacion de productos y subprductos, pero con los ids de numier, hay que encontrar que productos
      // se corresponden en sinqro.
      // Crear los json de productos que vayamos a mandar a sinqro usando el producto de prerelations
      var productsWithSubJson = [];
      var relationList = [];
      var vm = this;
      var config = {
        headers: {
          "x-api-server-access-token": vm.tokenServerSinqro,
          "x-api-user-access-token": vm.tokenUserSinqro,
        },
      };
      var metodo = "met4";
      vm.ejecucionTestList.forEach((element) => {
        if (element.metodo == metodo) {
          element.params = [true, false];
        }
      });

      prerelations.forEach((elementRel) => {
        var variantes = [];

        if (elementRel.producto.imgBase64 == "") {
          var data = "";
        } else {
          //var data = "data:image/jpeg;base64," + elementRel.producto.imgBase64;
          var data = elementRel.producto.imgBase64;
        }

        if (vm.isMasakali) {
          if (
            elementRel.producto.price2_d > 0 &&
            elementRel.producto.namePrice2_d != ""
          ) {
            var variante = {
              name: elementRel.producto.namePrice2_d,
              externalId: elementRel.producto.id,
              image: data,
              /*image: {
                filename:
                  elementRel.producto.nameProducto.trim() +
                  "-variant-foto.jpeg",
                data: data,
              },*/
              shortDescription: elementRel.producto.descripcion,
              price: {
                amount: elementRel.producto.price2_d,
                vatValue: 10.0,
              },
              id: null,
            };

            variantes.push(variante);
          }
          if (
            elementRel.producto.price3_d > 0 &&
            elementRel.producto.namePrice3_d != ""
          ) {
            var variante = {
              name: elementRel.producto.namePrice3_d,
              externalId: elementRel.producto.id,
              image: data,
              /*image: {
                filename:
                  elementRel.producto.nameProducto.trim() +
                  "-variant-foto.jpeg",
                data: data,
              },*/
              shortDescription: elementRel.producto.descripcion,
              price: {
                amount: elementRel.producto.price3_d,
                vatValue: 10.0,
              },
              id: null,
            };

            variantes.push(variante);
          }

          if (
            elementRel.producto.price4_d > 0 &&
            elementRel.producto.namePrice4_d != ""
          ) {
            var variante = {
              name: elementRel.producto.namePrice4_d,
              externalId: elementRel.producto.id,
              image: data,
              /*image: {
                filename:
                  elementRel.producto.nameProducto.trim() +
                  "-variant-foto.jpeg",
                data: data,
              },*/
              shortDescription: elementRel.producto.descripcion,
              price: {
                amount: elementRel.producto.price4_d,
                vatValue: 10.0,
              },
              id: null,
            };

            variantes.push(variante);
          }
        } else {
          if (
            elementRel.producto.price2 > 0 &&
            elementRel.producto.namePrice2 != ""
          ) {
            var variante = {
              name: elementRel.producto.namePrice2,
              externalId: elementRel.producto.id,
              image: data,
              /*image: {
                filename:
                  elementRel.producto.nameProducto.trim() +
                  "-variant-foto.jpeg",
                data: data,
              },*/
              shortDescription: elementRel.producto.descripcion,
              price: {
                amount: elementRel.producto.price2,
                vatValue: 10.0,
              },
              id: null,
            };

            variantes.push(variante);
          }
          if (
            elementRel.producto.price3 > 0 &&
            elementRel.producto.namePrice3 != ""
          ) {
            var variante = {
              name: elementRel.producto.namePrice3,
              externalId: elementRel.producto.id,
              image: data,
              /*image: {
                filename:
                  elementRel.producto.nameProducto.trim() +
                  "-variant-foto.jpeg",
                data: data,
              },*/
              shortDescription: elementRel.producto.descripcion,
              price: {
                amount: elementRel.producto.price3,
                vatValue: 10.0,
              },
              id: null,
            };

            variantes.push(variante);
          }

          if (
            elementRel.producto.price4 > 0 &&
            elementRel.producto.namePrice4 != ""
          ) {
            var variante = {
              name: elementRel.producto.namePrice4,
              externalId: elementRel.producto.id,
              image: data,
              /*image: {
                filename:
                  elementRel.producto.nameProducto.trim() +
                  "-variant-foto.jpeg",
                data: data,
              },*/
              shortDescription: elementRel.producto.descripcion,
              price: {
                amount: elementRel.producto.price4,
                vatValue: 10.0,
              },
              id: null,
            };

            variantes.push(variante);
          }
        }

        var listaIdRefs = elementRel.idRefList;
        var listaReferencias = [];
        var jsonProduct = {
          name: elementRel.producto.nameProducto,
          externalId: elementRel.producto.id,
          price: {
            amount: elementRel.producto.precio,
            vatValue: "10",
          },
          inMenuPrice: {
            amount: elementRel.producto.precio,
            vatValue: "10",
          },
          shortDescription: elementRel.producto.descripcion,
          description: elementRel.producto.descripcion,
          image: data,
          /*image: {
            filename: elementRel.producto.nameProducto.trim() + "-foto.jpeg",
            data: data,
          },*/
          public: elementRel.producto.baja == 1 ? false : true,
          featured: false,
          isAvailable: elementRel.producto.noDisponible == 1 ? false : true,
          addProductOptionsToVariants: true,
          productVariants: variantes,
          tags: [],
          productOptionsIds: listaReferencias,
        };

        listaIdRefs.forEach((elementIdRef) => {
          categoryEditedList.forEach((elementCat) => {
            var prodOptionsList = elementCat.productOptions;
            prodOptionsList.forEach((elementProd) => {
              if (elementProd.externalId == elementIdRef) {
                listaReferencias.push(elementProd.id);
              }
            });
          });
        });

        productsWithSubJson.push(jsonProduct);
      });
      var vm = this;
      productsWithSubJson.forEach((element) => {
        vm.axios
          .post(
            "https://api.sinqro.com/pos-app/v1/sellingPoints/" +
            vm.sellingPoint +
            "/products",
            element,
            config
          )
          .then(function (response) {
            var idProdIdSinq = {
              productId: response.data.externalId,
              productIdSinqro: response.data.id,
            };
            relationList.push(idProdIdSinq);
            if (productsWithSubJson.length == relationList.length) {
              vm.ejecucionTestList.forEach((element) => {
                if (element.metodo == metodo) {
                  element.params = [true, true];
                }
              });
              setTimeout(() => {
                vm.actualizarIdSinqro(relationList); // XP
                vm.allRelsProd = vm.allRelsProd.concat(relationList);
                vm.actualizarIds += 1;
              }, 1500);
            }
          })
          .catch(function (error) {
            vm.loading.close();

            swal({
              title: "¡Lo sentimos!",
              text:
                "Se ha producido un error en Sinqro. Intente realizar la importación nuevamente.",
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          });
      });
    },

    crearCategorySinqro(categoriesToCreateList) {
      var listaCategoriasAux = [
        {
          name: "(BASES) ¿Quieres quitar algo?",
          externalId: null,
          shortDescription: "Base",
          minOptions: 0,
          maxOptions: 1,
          maxSameOptionSelection: 0,
          position: 1,
          productOptions: [],
        },
        {
          name: "(EXTRAS) Añade lo que quieras",
          externalId: null,
          shortDescription: "Extra",
          minOptions: 0,
          maxOptions: 20,
          maxSameOptionSelection: 5,
          position: 1,
          productOptions: [],
        },
        {
          name: "(Opcionales) Elige uno",
          externalId: null,
          shortDescription: "Optional",
          minOptions: 0,
          maxOptions: 1,
          maxSameOptionSelection: 1,
          position: 1,
          productOptions: [],
        },
      ];
      var vm = this;
      var config = {
        headers: {
          "x-api-server-access-token": vm.tokenServerSinqro,
          "x-api-user-access-token": vm.tokenUserSinqro,
        },
      };
      var listaRels = [];
      if (categoriesToCreateList.length != 0) {
        categoriesToCreateList.forEach(function (element, i) {
          var nextIndex = i + 1;
          vm.axios
            .post(
              "https://api.sinqro.com/pos-app/v1/sellingPoints/" +
              vm.sellingPoint +
              "/productOptionsCategories",
              element,
              config
            )
            .then(function (responseCatPost) {
              vm.productsOptionsSinqroList.push(responseCatPost.data);
              if (
                categoriesToCreateList.length ==
                vm.productsOptionsSinqroList.length
              ) {
                vm.prepararProductoConSubSinqro();
              }
            })
            .catch(function (error) {
              vm.loading.close();
              console.log(error);
            });
        });
      } else {
        listaCategoriasAux.forEach(function (element, i) {
          var nextIndex = i + 1;
          vm.axios
            .post(
              "https://api.sinqro.com/pos-app/v1/sellingPoints/" +
              vm.sellingPoint +
              "/productOptionsCategories",
              element,
              config
            )
            .then(function (responseCatPost) {
              vm.productsOptionsSinqroList.push(responseCatPost.data);

              if (
                listaCategoriasAux.length == vm.productsOptionsSinqroList.length
              ) {
              }
            })
            .catch(function (error) {
              vm.loading.close();
              console.log(error);
            });
        });
      }
    },
    prepararProductoConSubSinqro() {
      var productsWithSubJson = [];
      var lista = [];
      var contador = 0;
      var longitud = this.prodSubprodRelationList.length;
      var vm = this;

      lista = this.prodSubprodRelationList;

      this.prodSubprodRelationList.forEach((elementRel) => {
        contador += 1;

        var listaIdRefs = elementRel.idRefList;
        var listaReferencias = [];
        var variantes = [];

        if (elementRel.producto.imgBase64 == "") {
          var data = "";
        } else {
          //var data = "data:image/jpeg;base64," + elementRel.producto.imgBase64;
          var data = elementRel.producto.imgBase64;
        }

        if (vm.isMasakali) {
          if (
            elementRel.producto.price2_d >= 0 &&
            elementRel.producto.namePrice2_d != ""
          ) {
            var variante = {
              name: elementRel.producto.namePrice2_d,
              externalId: elementRel.producto.id,
              image: data,
              /*image: {
                filename:
                  elementRel.producto.nameProducto.trim() +
                  "-variant-foto.jpeg",
                data: data,
              },*/
              shortDescription: elementRel.producto.descripcion,
              price: {
                amount: elementRel.producto.price2_d,
                vatValue: 10.0,
              },
              id: null,
            };

            variantes.push(variante);
          }
          if (
            elementRel.producto.price3_d >= 0 &&
            elementRel.producto.namePrice3_d != ""
          ) {
            var variante = {
              name: elementRel.producto.namePrice3_d,
              externalId: elementRel.producto.id,
              image: data,
              /*image: {
                filename:
                  elementRel.producto.nameProducto.trim() +
                  "-variant-foto.jpeg",
                data: data,
              },*/
              shortDescription: elementRel.producto.descripcion,
              price: {
                amount: elementRel.producto.price3_d,
                vatValue: 10.0,
              },
              id: null,
            };

            variantes.push(variante);
          }

          if (
            elementRel.producto.price4_d >= 0 &&
            elementRel.producto.namePrice4_d != ""
          ) {
            var variante = {
              name: elementRel.producto.namePrice4_d,
              externalId: elementRel.producto.id,
              image: data,
              /*image: {
                filename:
                  elementRel.producto.nameProducto.trim() +
                  "-variant-foto.jpeg",
                data: data,
              },*/
              shortDescription: elementRel.producto.descripcion,
              price: {
                amount: elementRel.producto.price4_d,
                vatValue: 10.0,
              },
              id: null,
            };

            variantes.push(variante);
          }
        } else {
          if (
            elementRel.producto.price2 >= 0 &&
            elementRel.producto.namePrice2 != ""
          ) {
            var variante = {
              name: elementRel.producto.namePrice2,
              externalId: elementRel.producto.id,
              image: data,
              /*image: {
                filename:
                  elementRel.producto.nameProducto.trim() +
                  "-variant-foto.jpeg",
                data: data,
              },*/
              shortDescription: elementRel.producto.descripcion,
              price: {
                amount: elementRel.producto.price2,
                vatValue: 10.0,
              },
              id: null,
            };

            variantes.push(variante);
          }
          if (
            elementRel.producto.price3 >= 0 &&
            elementRel.producto.namePrice3 != ""
          ) {
            var variante = {
              name: elementRel.producto.namePrice3,
              externalId: elementRel.producto.id,
              image: data,
              /*image: {
                filename:
                  elementRel.producto.nameProducto.trim() +
                  "-variant-foto.jpeg",
                data: data,
              },*/
              shortDescription: elementRel.producto.descripcion,
              price: {
                amount: elementRel.producto.price3,
                vatValue: 10.0,
              },
              id: null,
            };

            variantes.push(variante);
          }

          if (
            elementRel.producto.price4 >= 0 &&
            elementRel.producto.namePrice4 != ""
          ) {
            var variante = {
              name: elementRel.producto.namePrice4,
              externalId: elementRel.producto.id,
              image: data,
              /*image: {
                filename:
                  elementRel.producto.nameProducto.trim() +
                  "-variant-foto.jpeg",
                data*/
              shortDescription: elementRel.producto.descripcion,
              price: {
                amount: elementRel.producto.price4,
                vatValue: 10.0,
              },
              id: null,
            };

            variantes.push(variante);
          }
        }

        let precio1 = 0;
        if (vm.isMasakali) {
          precio1 = elementRel.producto.price1_d;
        } else {
          precio1 = elementRel.producto.price1;
        }

        var jsonProduct = {
          name: elementRel.producto.nameProducto,
          externalId: elementRel.producto.id,
          price: {
            amount: precio1,
            vatValue: "10",
          },
          inMenuPrice: {
            amount: precio1,
            vatValue: "10",
          },
          shortDescription: elementRel.producto.descripcion,
          description: elementRel.producto.descripcion,
          image: data,
          /*image: {
            filename: elementRel.producto.nameProducto.trim() + "-foto.jpeg",
            data: data,
          },*/
          public: elementRel.producto.baja == 1 ? false : true,
          featured: false,
          isAvailable: elementRel.producto.noDisponible == 1 ? false : true,
          addProductOptionsToVariants: true,
          productVariants: variantes,
          tags: [],
          productOptionsIds: listaReferencias,
          idNoSubir: elementRel.producto.idProductAgencia,
        };

        listaIdRefs.forEach((elementIdRef) => {
          this.productsOptionsSinqroList.forEach((elementCat) => {
            var prodOptionsList = elementCat.productOptions;
            prodOptionsList.forEach((elementProd) => {
              if (elementProd.externalId == elementIdRef) {
                listaReferencias.push(elementProd.id);
              }
            });
          });
        });

        productsWithSubJson.push(jsonProduct);

        if (contador == longitud) {
          this.crearProductoConSubSinqro(productsWithSubJson);
        }
      });
    },
    crearProductoConSubSinqro(productsList) {
      var relationList = [];
      var vm = this;
      var config = {
        headers: {
          "x-api-server-access-token": this.tokenServerSinqro,
          "x-api-user-access-token": this.tokenUserSinqro,
        },
      };
      var metodo = "met3";
      vm.ejecucionTestList.forEach((element) => {
        if (element.metodo == metodo) {
          element.params = [true, false];
        }
      });
      productsList.forEach(function (element, i) {
        var idAgenciaArr = vm.prodSubprodRelationList.filter(
          (prod) =>
            prod.producto.id == element.externalId &&
            prod.producto.idProductAgencia == element.idNoSubir
        );
        if (
          idAgenciaArr.length != 0 &&
          idAgenciaArr[0].producto.hasOwnProperty("idAgenciaSinqro")
        ) {
          var idAgenciaSinqro = idAgenciaArr[0].producto.idAgenciaSinqro;
        } else {
          var idAgenciaSinqro = 0;
        }

        vm.axios
          .post(
            "https://api.sinqro.com/pos-app/v1/sellingPoints/" +
            vm.sellingPoint +
            "/products",
            element,
            config
          )
          .then(function (response) {
            var idProdIdSinq = {
              productId: response.data.externalId,
              productIdSinqro: response.data.id,
              idAgenciaSinqro: idAgenciaSinqro,
            };
            relationList.push(idProdIdSinq);

            if (productsList.length == relationList.length) {
              vm.sinqroFinalizado.productosConSubproductos = true;

              vm.ejecucionTestList.forEach((element) => {
                if (element.metodo == metodo) {
                  element.params = [true, true];
                }
              });
              setTimeout(() => {
                vm.actualizarIdSinqro(relationList); //XP
                vm.allRelsProd = vm.allRelsProd.concat(relationList);
                vm.actualizarIds += 1;
              }, 1500);
            }
          })
          .catch(function (error) {
            console.log(error);
            vm.loading.close();

            swal({
              title: "¡Lo sentimos!",
              text:
                "Se ha producido un error en Sinqro. Intente realizar la importación nuevamente.",
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          });
      });
    },

    relacionarAllProds() {
      let numierProducts = this.productsNumierList;
      this.getProductsSinqro();
      var relaciones = [];

      Promise.all([p1]).then(() => {
        var sinqroProducts = this.productsSinqroList;
        numierProducts.forEach((prodNum) => {
          sinqroProducts.forEach((prodSinq) => {
            if (prodNum.id == prodSinq.externalId) {
              var jsonRelsIds = {
                idSinqro: prodSinq.id,
                idNumier: prodNum.id,
              };
              relaciones.push(jsonRelsIds);
            }
          });
        });
      });
    },

    actualizarIdSinqro(relationList) {
      var vm = this;
      var listaComprobante = [];
      var done = vm.comprobarEjecuciones();
      relationList.forEach((element) => {
        var config = {
          params: {
            jwt: this.$store.getters.jwt,
          },
          headers: { Authorization: "Bearer " + this.$store.getters.jwt },
        };

        var params = {
          idBusiness: this.idBusiness,
          idProduct: element.productId,
          idSinqro: element.productIdSinqro,
          idAgenciaSinqro: element.idAgenciaSinqro,
          jwt: this.$store.getters.jwt,
        };

        vm.axios
          .post(
            this.$store.getters.apiUrl + "delivery/updateIdSinqro",

            params,
            config
          )
          .then(function (response) {
            listaComprobante.push(response);

            if (
              listaComprobante.length == relationList.length &&
              done &&
              !vm.abierto &&
              vm.relsDone &&
              vm.productsOptionsSinqroList.length >= 3
            ) {
              if (vm.sinqroFinalizado.ambosListos > 0) {
                vm.abierto = true;
              }

              vm.getProductoNumier(true);

              setTimeout(() => {
                vm.loading.close();
                vm.loading = Loading.service({
                  text: vm.$t("generandoCarta"),
                });
              }, 1000);
            }
          })
          .catch(function (error) {
            console.log(error);
            vm.loading.close();
          });
      });
    },

    actualizarIdNumierToCero() {
      var vm = this;
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      var params = {
        idBusiness: this.idBusiness,
        jwt: this.$store.getters.jwt,
      };

      vm.axios
        .post(
          this.$store.getters.apiUrl + "delivery/updateIdSinqroToCero",
          params,
          config
        )
        .then(function (response) {
          vm.loading.close();

          vm.loading = Loading.service({
            text: vm.$t("importandoProductos"),
          });

          vm.getProductoNumier(false);
        })
        .catch(function (error) {
          console.log(error);
          vm.loading.close();
        });
    },
    prepararCarta() {
      this.preparadaCarta = true;
      var contador = 0;
      while (!this.relsDone && contador < 1000) {
        contador++;
      } // || !this.catsDone
      var typesOrder = [];
      if (this.noRecoger == "0" && this.noDomicilio == "0") {
        typesOrder = ["delivery", "collection"];
      } else if (this.noRecoger == "1" && this.noDomicilio == "0") {
        typesOrder = ["delivery"];
      } else if (this.noRecoger == "0" && this.noDomicilio == "1") {
        typesOrder = ["collection"];
      }
      var allRelsProdLocal = [];

      var prdoNumList = JSON.parse(JSON.stringify(this.productsNumierList));
      prdoNumList.forEach((prodNum) => {
        var idProdIdSinq = {
          productId: prodNum.id,
          productIdSinqro: prodNum.idSinqro,
        };

        allRelsProdLocal.push(idProdIdSinq);
      });

      var vm = this;
      var config = {
        headers: {
          "x-api-server-access-token": this.tokenServerSinqro,
          "x-api-user-access-token": this.tokenUserSinqro,
        },
      };
      var secciones = [];
      var listaCatProdSinq = [];
      var cartaList = [];

      function restarDias(fecha, dias) {
        fecha.setDate(fecha.getDate() - dias);
        return fecha;
      }
      var d = new Date();
      var ayer = restarDias(d, 1);

      var fechaStart = ayer;

      // sacar las relaciones de la tabla products cuando no esten todos los productos.
      this.ProdCategoriRelationList.forEach((catProdRel) => {
        var listaIdSinq = [];
        catProdRel.productsIdList.forEach((idProd) => {
          allRelsProdLocal.forEach((idRel) => {
            if (idRel.productId == idProd) {
              listaIdSinq.push(idRel.productIdSinqro);
            }
          });
        });
        var relsJsonSinq = {
          idCategory: catProdRel.idCategoria,
          idSinqProds: listaIdSinq,
        };

        if (relsJsonSinq.idSinqProds.length != 0) {
          listaCatProdSinq.push(relsJsonSinq);
        }
      });

      var catNumList = JSON.parse(JSON.stringify(this.categoriesNumierList));

      listaCatProdSinq.forEach((catProd) => {
        catNumList.forEach((catNum) => {
          if (catProd.idCategory == catNum.id) {
            var seccion = {
              externalId: catNum.id,
              name: catNum.nombre,
              shortDescription: catNum.descripcion,
              position: catNum.orden,
              productsIds: catProd.idSinqProds,
            };

            secciones.push(seccion);
          }
        });
      });
      var carta = {
        name: "Nuestra carta",
        externalId: null,
        type: "menu",
        position: 1,
        public: true,
        allowedOrderTypes: typesOrder,
        availableFrom: fechaStart,
        availableTo: null,
        shortDescription: this.descripcionCarta,
        menuSections: secciones,
      };

      cartaList.push(carta);

      this.axios
        .get(
          "https://api.sinqro.com/pos-app/v1/sellingPoints/" +
          vm.sellingPoint +
          "/menus",
          config
        )
        .then(function (response) {
          if (response.data.length != 0) {
            vm.borrarCartasObsoletas(response.data, cartaList);
          } else {
            vm.crearCarta(cartaList);
          }
        })
        .catch(function (error) {
          vm.loading.close();
          console.log(error);
        });
    },
    borrarCartasObsoletas(cartaToDelete, cartaList) {
      var asinqList = [];
      var vm = this;
      var config = {
        headers: {
          "x-api-server-access-token": this.tokenServerSinqro,
          "x-api-user-access-token": this.tokenUserSinqro,
        },
      };

      cartaToDelete.forEach((element) => {
        this.axios
          .delete(
            "https://api.sinqro.com/pos-app/v1/sellingPoints/" +
            vm.sellingPoint +
            "/menus/" +
            element.id,
            config
          )
          .then(function (response) {
            asinqList.push(response);

            if (cartaToDelete.length == asinqList.length) {
              vm.crearCarta(cartaList);
            }
          })
          .catch(function (error) {
            vm.loading.close();
            console.log(error);
          });
      });
    },
    crearCarta(cartaList) {
      var responseCarta = undefined;
      var vm = this;
      var config = {
        headers: {
          "x-api-server-access-token": this.tokenServerSinqro,
          "x-api-user-access-token": this.tokenUserSinqro,
        },
      };

      this.axios
        .post(
          "https://api.sinqro.com/pos-app/v1/sellingPoints/" +
          vm.sellingPoint +
          "/menus/collection",
          cartaList,
          config
        )
        .then(function (response) {
          responseCarta = response.data;
          vm.actualizarIdCarta(responseCarta);

          vm.loading.close();
          if (!vm.llamado) {
            vm.openModalFinDeProceso();

            vm.llamado = true;
          }
        })
        .catch(function (error) {
          vm.loading.close();
          console.log(error);
        });
    },
    actualizarIdCarta(responseCarta) {
      var listaRels = [];
      responseCarta.forEach((res) => {
        var jsonrelcarta = {
          idNum: res.externalId,
          idSinq: res.id,
        };
        listaRels.push(jsonrelcarta);
      });

      listaRels.forEach((element) => {
        //TODO
      });
    },
    /**Helper delete */

    reset() {
      var vm = this;
      vm.sinqroFinalizado.noExistenProductosConSubproductos = false;
      vm.sinqroFinalizado.noExistenProductosSinSubproductos = false;
      vm.sinqroFinalizado.productosConSubproductos = false;
      vm.sinqroFinalizado.productosSinSubproductos = false;
      vm.sinqroFinalizado.ambosListos = 0;
      vm.tratandoSubproductos = false;
      vm.preparadaCarta = false;
      vm.abierto = false;
      vm.llamado = false;
      vm.forCreate = false;
      vm.productsSinqroList = [];
      vm.productsNumierList = [];
      vm.categoriesToImport = [];
      vm.checkAllCategories = false;
      vm.isIndeterminate = true;
      // vm.categoriesNumierList = [];
      vm.productsOptionsSinqroList = [];
      vm.productSubproductList = [];
      vm.prodSubprodRelationList = [];
      vm.ProdCategoriRelationList = [];
      vm.prodSubprodCreateList = [];
      vm.actualizarIds = 0;
      vm.abierto = false;
      vm.allRelsProd = [];
      vm.relsDone = false;
      vm.catsDone = false;
      vm.noRecoger = true;
      vm.noDomicilio = false;
      vm.agenciasSinqroList = [];
      vm.ejecucionTestList = [
        {
          metodo: "met1",
          params: [false, false],
        },
        {
          metodo: "met2",
          params: [false, false],
        },
        {
          metodo: "met3",
          params: [false, false],
        },
        {
          metodo: "met4",
          params: [false, false],
        },
      ];
    },
    deleteSinqro(forDel) {
      this.forCreate = forDel;
      var vm = this;

      var config = {
        headers: {
          "x-api-server-access-token": this.tokenServerSinqro,
          "x-api-user-access-token": this.tokenUserSinqro,
        },
      };
      this.axios
        .post(
          "https://api.sinqro.com/pos-app/v1/sellingPoints/" +
          vm.sellingPoint +
          "/truncate",
          "",
          config
        )
        .then(function (response) {
          // if (!forDel) {
          //   //metodo para actualizar a 0 los ids.
          //   vm.actualizarIdSinqroToCero(forDel);
          // } else {
          //Metodo truncate
          var config = {
            params: {
              jwt: vm.$store.getters.jwt,
            },
            headers: { Authorization: "Bearer " + vm.$store.getters.jwt },
          };

          var params = {
            idBusiness: vm.idBusiness,
            jwt: vm.$store.getters.jwt,
          };

          vm.axios
            .post(
              vm.$store.getters.apiUrl + "delivery/updateIdSinqroToCero",
              params,
              config
            )
            .then(function (response) {
              swal({
                title: vm.$t("procesoCompletado"),
                text: vm.$t("finProgres"),
                type: "success",
                showCancelButton: false,
                confirmButtonClass: "btn btn-success btn-fill",
                cancelButtonClass: "btn btn-danger btn-fill",
                confirmButtonText: vm.$t("vale"),
                cancelButtonText: vm.$t("cancelar"),
                buttonsStyling: true,
              }).then(() => {
                this.reset();
              });
            })
            .catch(function (error) {
              console.log(error);
              vm.loading.close();
            });
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    /***********************************************************************************************/

    cambiarIdiomaAProducto(obj) {
      if (this.traduccion.trim() === "") {
        swal({
          title: "¡Lo sentimos!",
          text: "No puede guardar en blanco la traducción de un producto",
          confirmButtonClass: "btn btn-info btn-fill",
          type: "error",
        });
      } else {
        //Le añadimos al producto las traducciones
        obj.traduccion = this.traduccion;
        obj.traduccionDesc = this.traduccionDesc;

        var config = {
          params: {
            jwt: this.$store.getters.jwt,
          },
          headers: { Authorization: "Bearer " + this.$store.getters.jwt },
        };
        var params = {
          idBusinessInfo: this.idCarta,
          producto: obj,
          jwt: this.$store.getters.jwt,
          idLang: this.selectedLang,
        };

        let vm = this;
        let controller = "cambiarIdiomaAProducto";
        this.axios
          .post(
            this.$store.getters.apiUrl + "delivery/" + controller,
            params,
            config
          )
          .then(function (response) {
            if (response.data.response) {
              vm.getProductosCarta();
              vm.$modal.hide("anadir-idioma");
              let notify = "modificada";
              vm.$notify({
                message:
                  vm.$t("traduccion") +
                  " " +
                  notify +
                  " " +
                  vm.$t("correctamente"),
                icon: "nc-icon nc-check-2",
                timeout: 2000,
                horizontalAlign: "right",
                verticalAlign: "top",
                type: "success",
              });
            } else {
              swal({
                title: vm.$t("atencion"),
                text: response.data.message,
                confirmButtonClass: "btn btn-info btn-fill",
                type: "error",
              });
            }
          })
          .catch(function (error) {
            console.log(error);
            vm.inProgress = false;
          });
      }
    },

    // Guarda el producto actual en productoEditar para identificarlo más tarde.
    // Llama a getIdiomasCarta() para obtener los idiomas asociados al negocio y mostrar el modal de traducción. 
    abrirModalIdiomas(producto) {
      this.productTranslations = [];
      this.productoEditar = producto;
      this.getIdiomasCarta();
    },

    // Recupera de la API la lista de idiomas disponibles para el negocio:
      // Envía una petición GET al servidor con datos como idBusinessInfo.
      // Si hay idiomas: Llama a getTraducciones() para obtener las traducciones existentes.
      // Si no hay idiomas: Muestra un mensaje de error con swal.
    getIdiomasCarta() {

      var config = {
        params: {
          jwt: this.$store.getters.jwt,
          idBusinessInfo: this.idCarta,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      var vm = this;
      this.axios
        .get(vm.$store.getters.apiUrl + "delivery/getLangBusinessInfo", config)
        .then(function (response) {
          if (response.data.response) {
            vm.langList = response.data.result;

            vm.selectedLang = response.data.result[0].idLang;

            if (vm.langList.length > 0) {
              vm.getTraducciones();
            } else {
              swal({
                title: vm.$t("atencion"),
                text: "Su carta no tiene ningún idioma asociado",
                confirmButtonClass: "btn btn-info btn-fill",
                type: "error",
              });
            }
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        });
    },

    // Obtiene las traducciones existentes para el producto seleccionado:
      // Revisa si hay traducciones para el idioma seleccionado (selectedLang).
      // Carga esas traducciones en las variables traduccion y traduccionDesc.
      // Muestra el modal con las traducciones usando vm.$modal.show("anadir-idioma").
    getTraducciones() {

      //Preparamos las id de los idiomas que vamos a utilizar para buscar las traducciones
      let langIdList = [];

      this.langList.forEach((lang) => {
        langIdList.push(lang.idLang);
      });

      var config = {
        params: {
          jwt: this.$store.getters.jwt,
          langList: langIdList,
          idBusinessInfo: this.idCarta,
          idProduct: this.productoEditar.id,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      var vm = this;
      this.axios
        .get(
          vm.$store.getters.apiUrl + "delivery/getLangProductCartaTranslations",
          config
        )
        .then(function (response) {
          if (response.data.response) {
            //Conseguimos las traducciones y seteamos las traducciones del primer idioma que recogimos
            vm.productTranslations = response.data.result;

            let idiomaSeleccionado = vm.productTranslations.find(
              (element) => element.idLang == vm.selectedLang
            );

            vm.traduccion = idiomaSeleccionado
              ? idiomaSeleccionado.traduccion
              : "";
            vm.traduccionDesc = idiomaSeleccionado
              ? idiomaSeleccionado.traduccionDesc
              : "";

            vm.$modal.show("anadir-idioma");
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        });
    },

    
    cambiarTraducciones() {
      //Buscamos las traducciones del idioma seleccionado
      let idiomaSeleccionado = this.productTranslations.find(
        (element) => element.idLang == this.selectedLang
      );

      this.traduccion = idiomaSeleccionado ? idiomaSeleccionado.traduccion : "";
      this.traduccionDesc = idiomaSeleccionado
        ? idiomaSeleccionado.traduccionDesc
        : "";
    },
    //REPLICADO
    getBusinessReplicado() {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      var vm = this;
      this.axios
        .get(
          vm.$store.getters.apiUrl + "general/getBusinessesByUserReplicado",
          config
        )
        .then(function (response) {
          if (response.data.response) {
            vm.listBusinessReply = response.data.result;
            vm.$modal.show("modalReply");
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        });
    },
    openModalEditar(obj) {
      this.cacheImagen++;

      this.productoEditar = obj;

      this.$modal.show("editar-producto");
    },

    getBusiness() {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "general/getBusinessesByUser", config)
        .then(function (response) {
          if (vm.$store.getters.idBusiness) {
            vm.idBusiness = vm.$store.getters.idBusiness;
            if (
              vm.$store.getters.idBusiness == 2753 ||
              vm.$store.getters.idBusiness == 4213 ||
              vm.$store.getters.idBusiness == 4426 ||
              vm.$store.getters.idBusiness == 4483 ||
              vm.$store.getters.idBusiness == 4554 ||
              vm.$store.getters.idBusiness == 4557 ||
              vm.$store.getters.idBusiness == 4604 ||
              vm.$store.getters.idBusiness == 3520 ||
              vm.$store.getters.idBusiness == 5984
            ) {
              vm.isMasakali = true;
            }
          } else {
            vm.idBusiness = response.data.result[0].id;
          }

          vm.listBusinesses = response.data.result;

          vm.editarProductos = false;

          vm.permisoCarta();
          vm.getCategoriesCarta();
          vm.searchProducto("");
          vm.getConfigDistinguirPrecio();
          vm.getConfigDistinguirPrecioCarta();
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    permisoCarta() {
      const selectedBusiness = this.listBusinesses.find(
        (business) => business.id == this.idBusiness
      );

      if (selectedBusiness && selectedBusiness.selfi === "1") {
                this.isSelfi = true;

                swal({
                    title: this.$t("nosmudamos"),
                    text: this.$t("noscambiamosaselfi"), // Puedes traducir este texto si usas i18n
                    confirmButtonClass: "btn btn-warning btn-fill",
                    type: "warning",
                    showCloseButton: true, // Muestra la "X" en la esquina superior derecha
                    confirmButtonText: this.$t("irASelfibar"), // Texto del botón de confirmación
                    reverseButtons: true, // Invierte los botones para que el botón de confirmación esté primero
                }).then((result) => {
                    console.log(result);
                    if (result.value) {
                        this.redirectToSelfibar();
                    }
                });
            } else {
                this.isSelfi = false;
      this.checkSinqroConfig();
      //Get categorias cuando cambia de negocio
      this.getCategoriesNumier();
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
          estado: this.estado,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      this.$store.dispatch("setIdBusiness", this.idBusiness);
      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "delivery/getPermisoCarta", config)
        .then(function (response) {
          if (response.data.response) {
            vm.listCartas = [
              {
                nombreMostrado: vm.$t("esteNegocioNoContieneNingunaCarta"),
                id: 0,
              },
            ];
            vm.idCarta = 0;

            if (response.data.result.permiso) {
              vm.permiso = response.data.result.permiso;
              vm.sellingPoint =
                response.data.result.listCartas[0].sinqroSellingPoint;

              //vm.nameRoute = response.data.result.nameroute;
              //vm.logoNegocio = response.data.result.imagen;

              vm.listCartas = response.data.result.listCartas;

              response.data.result.listCartas.forEach(function (x) {
                if (x.tokenServerSinqro) {
                  vm.tokenServerSinqro = x.tokenServerSinqro;
                }

                if (x.tokenUserSinqro) {
                  vm.tokenUserSinqro = x.tokenUserSinqro;
                }

                if (x.tiene_sinqro) {
                  if (x.tiene_sinqro == "1") {
                    vm.tieneSinqro = true;
                  } else {
                    vm.tieneSinqro = false;
                  }
                }

                if (x.noRecoger == true) {
                  vm.noRecoger = "1";
                } else {
                  vm.noRecoger = "0";
                }

                if (x.noDomicilio == true) {
                  vm.noDomicilio = "1";
                } else {
                  vm.noDomicilio = "0";
                }

                if (x.multiCartaSinqro == true) {
                  vm.multiCartaSinqro = true;
                } else {
                  vm.multiCartaSinqro = false;
                }
                let encontrado = false;
                x.config.forEach((element) => {
                  if (element.nombre == "tituloDestacados") {
                    vm.tituloDestacados = element.valor;
                    encontrado = true;
                  }
                });

                if (!encontrado) {
                  vm.tituloDestacados = "Productos destacados";
                }
              });
              vm.idCarta = response.data.result.listCartas[0].id;
              vm.lastUploadedSinqro =
                response.data.result.listCartas[0].lastUploadedSinqro;
              vm.descripcionCarta =
                response.data.result.listCartas[0].descripcionCarta;

              /*vm.noRecoger = response.data.result.listCartas[0].config.filter(
                (item) => item.idConfig == "22"
              )[0];
              vm.noDomicilio = response.data.result.listCartas[0].config.filter(
                (item) => item.idConfig == "7"
              )[0];*/
              vm.editarProductos = false;

              vm.searchProducto("");
              vm.getConfigDistinguirPrecio();
              vm.getConfigDistinguirPrecioCarta();
              vm.getProductosCarta();
              vm.getCategoriesCarta();
            } else {
              vm.permiso = response.data.result.permiso;
            }
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        });
      }
    },

    searchProductoCarta() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
          query: this.searchQuery,
          baja: this.baja,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.$store.dispatch("setIdBusiness", this.idBusiness);
      this.axios
        .get(
          this.$store.getters.apiUrl + "delivery/searchProductosCarta",
          config
        )
        .then(function (response) {
          if (response.data.response) {
            vm.activeCarta = vm.searchQuery === "" ? false : true;

            vm.listProductosCarta = response.data.result;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    editarImagen(obj) {
      if (!obj.img) {
        obj.editImage = true;

        obj.img = this.img;
      }
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      var params = {
        idBusiness: this.idBusiness,
        producto: obj,
        jwt: this.$store.getters.jwt,
      };

      let vm = this;
      let controller = "editarImagenProductoCarta";
      this.axios
        .post(
          this.$store.getters.apiUrl + "delivery/" + controller,
          params,
          config
        )
        .then(function (response) {
          if (response.data.response) {
            vm.getProductosCarta();
            vm.$modal.hide("editar-producto");

            vm.img = "";

            let notify = vm.$t("editada");
            vm.$notify({
              message:
                vm.$t("imagen") + " " + notify + " " + vm.$t("correctamente"),
              icon: "nc-icon nc-check-2",
              timeout: 2000,
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "success",
            });
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function (error) {
          console.log(error);
          vm.inProgress = false;
        });
    },
    openModalFinDeProceso() {
      swal({
        title: this.$t("procesoCompletado"),
        text: this.$t("finProgres"),
        type: "success",
        showCancelButton: false,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: this.$t("vale"),
        cancelButtonText: this.$t("cancelar"),
        buttonsStyling: true,
      }).then((result) => {
        this.reset();
      });
    },
    openModalErrorSelectCategories() {
      swal({
        title: this.$t("errorCategorySelect"),
        text: this.$t("txtErrorCategorySelect"),
        type: "warning",
        showCancelButton: false,
        confirmButtonClass: "btn btn-success btn-fill",
        confirmButtonText: this.$t("vale"),
        buttonsStyling: true,
      }).then((result) => {
        this.reset();
      });
    },

    openModalNoDisponible(id, baja) {
      if (this.tieneSinqro) {
        if (baja) {
          swal({
            title: this.$t("estasSeguroDeDarDeAltaElProducto"),
            text: this.$t("podraDarloDeBajaEnUnFuturo"),
            type: "error",
            showCancelButton: true,
            confirmButtonClass: "btn btn-success btn-fill",
            cancelButtonClass: "btn btn-danger btn-fill",
            confirmButtonText: this.$t("siDarDeAlta"),
            cancelButtonText: this.$t("cancelar"),
            buttonsStyling: true,
          }).then((result) => {
            if (result.value) {
              this.changeNoDisponible(id, baja);
            }
          });
        } else {
          swal({
            title: this.$t("estasSeguroDeDarDeBajaElProducto"),
            text: this.$t("podraDarloDeAltaEnUnFuturo"),
            type: "question",
            showCancelButton: true,
            confirmButtonClass: "btn btn-success btn-fill",
            cancelButtonClass: "btn btn-danger btn-fill",
            confirmButtonText: this.$t("siDarDeBaja"),
            cancelButtonText: this.$t("cancelar"),
            buttonsStyling: true,
          }).then((result) => {
            if (result.value) {
              this.changeNoDisponible(id, baja);
            }
          });
        }
      } else {
        this.changeNoDisponible(id, baja);
      }
    },
    openModalImportador(forDel) {
      swal({
        title: this.$t("estasSeguroDeImportarTusProductosASinqro"),
        text: this.$t("esteProcesoPuedeTardarVariosMinutos"),
        type: "question",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: this.$t("siImportarConSinqro"),
        cancelButtonText: this.$t("cancelar"),
        buttonsStyling: true,
      }).then((result) => {
        if (result.value) {
          //Open modal select categorias
          this.$modal.show("modalSelectCategory");
        }
      });
    },
    changeNoDisponible(id, baja) {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      var params = {
        idBusiness: this.idBusiness,
        idProducto: id,
        baja: baja,
        jwt: this.$store.getters.jwt,
      };

      let vm = this;
      let controller = "updateDisponibleProducto";
      this.axios
        .post(
          this.$store.getters.apiUrl + "delivery/" + controller,
          params,
          config
        )
        .then(function (response) {
          if (response.data.response) {
            vm.getProductosCarta();

            let notify = vm.$t("editado");
            vm.$notify({
              message:
                vm.$t("producto") + " " + notify + " " + vm.$t("correctamente"),
              icon: "nc-icon nc-check-2",
              timeout: 2000,
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "success",
            });
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function (error) {
          console.log(error);
          vm.inProgress = false;
        });
    },

    getProductosCarta() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
          idTipo: this.idTipo,
          idCarta: this.idCarta,
          baja: this.baja,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.$store.dispatch("setIdBusiness", this.idBusiness);
      this.axios
        .get(this.$store.getters.apiUrl + "delivery/getProductsCarta", config)
        .then(function (response) {
          if (response.data.response) {
            vm.listProductosCarta = response.data.result;

            vm.respuesta = true;
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });

            vm.respuesta = false;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
      const tempconfig = this.listCartas.find((elm) => elm.id == this.idCarta)
        .config;

      /*this.listCartas.forEach(carta => {
        if(this.idCarta == carta.id) {
          this.sellingPoint = carta.sellingPoint;
        }
      });*/

      if (tempconfig && tempconfig.length > 0) {
        tempconfig.forEach((element) => {
          const el = {};
          el[element.nombre] = element.valor != 0;
          Object.assign(this.configcarta, el);
          //  this.configcarta.push(el)
        });
      }
    },

    onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.createImage(files[0]);
    },

    createImage(file) {
      var reader = new FileReader();
      var vm = this;
      reader.onload = (e) => {
        vm.img = e.target.result;
      };
      reader.readAsDataURL(file);
    },

    removeProductoCarta() {
      this.activeCarta = false;
      this.searchQuery = "";
      this.getProductosCarta();
    },

    modalConfirmation() {
      swal({
        title: this.$t(
          "estasSeguroDeReplicarTodosLosProductosALosNegociosSeleccionados"
        ),
        text: this.$t("estaAccionNoSePuedeDeshacer"),
        type: "info",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: this.$t("siReplicar"),
        cancelButtonText: this.$t("cancelar"),
        buttonsStyling: true,
      }).then((result) => {
        if (result.value) {
          this.replyProducts();
        }
      });
    },
    replyProducts() {
      var listBuinessReply = this.listBusinessReply.filter(
        (bussines) => bussines.checked
      );

      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      var params = {
        idBusiness: this.idBusiness,
        listBusinesses: listBuinessReply,
        idCarta: this.idCarta,
        jwt: this.$store.getters.jwt,
      };
      this.axios
        .post(
          this.$store.getters.apiUrl + "delivery/replyAllProducts",
          params,
          config
        )
        .then(function (response) {
          vm.$modal.hide("modalReply");

          // if (response.data.response) {
          //     vm.closeModal();
          // } else {
          //     swal({
          //         title: `Atención`,
          //         text: response.data.message,
          //         confirmButtonClass: 'btn btn-info btn-fill',
          //         type: 'error'
          //     });
          //
          //
          // }
        })
        .catch(function (error) {
          console.log(error);
          vm.inProgress = false;
        });
    },
    selectAll() {
      if (this.checkSelectAll) {
        this.listBusinesses.forEach(function (business) {
          business.checked = false;
        });
      } else {
        this.listBusinesses.forEach(function (business) {
          business.checked = true;
        });
      }
    },

    selectAllCategories() {
      if (this.checkSelectAllCategories) {
        this.categoriesNumierList.forEach(function (category) {
          category.checked = false;
        });
      } else {
        this.categoriesNumierList.forEach(function (category) {
          category.checked = true;
        });
      }
    },

    changeIsDeBaja() {
      this.getProductosCarta();
    },

    getConfigDistinguirPrecio() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
          numConfig: 55,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.$store.dispatch("setIdBusiness", this.idBusiness);
      this.axios
        .get(this.$store.getters.apiUrl + "general/getConfigTpv", config)
        .then(function (response) {
          if (response.data.response) {
            vm.distinguirPrecios = true;
          } else {
            vm.distinguirPrecios = false;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getConfigDistinguirPrecioCarta() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
          numConfig: 89,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.$store.dispatch("setIdBusiness", this.idBusiness);
      this.axios
        .get(this.$store.getters.apiUrl + "general/getConfigTpv", config)
        .then(function (response) {
          if (response.data.response) {
            vm.distinguirPreciosCarta = true;
          } else {
            vm.distinguirPreciosCarta = false;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
     redirectToSelfibar() {
      const jwt = this.$store.getters.jwt;

      // Construye la URL con el parámetro JWT
      // const targetUrl = `http://127.0.0.1:5173/validate-user?jwt=${encodeURIComponent(jwt)}`;
      // const targetUrl = `https://dev.selfibar.com/validate-user?jwt=${encodeURIComponent(jwt)}`;
      const targetUrl = `https://selfibar.com/online/validate-user?jwt=${encodeURIComponent(jwt)}`;


      // Abre la URL en una nueva pestaña
      window.open(targetUrl, '_blank');
    },
  },

  components: {
    [DatePicker.name]: DatePicker,
    [Select.name]: Select,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Button.name]: Button,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [Option.name]: Option,
  },
};
</script>

<style>
@media (max-width: 992px) {
  .modalCategorySelect .v--modal {
    flex-direction: column !important;
    justify-content: center !important;
    width: 100% !important;
    max-width: 100% !important;
    /* padding: 1.25em !important ;  */
    border-radius: 0.3125em !important;
    background: white !important;
    font-family: inherit !important;
    font-size: 1rem !important;
    box-sizing: border-box !important;
    top: 7vh !important;
    left: 0px !important;
    height: auto !important;
  }

  .modalCategorySelect .el-checkbox {
    min-width: 85% !important;
  }

  .modalCategorySelect .el-checkbox-group {
    padding-left: 12% !important;
  }
}
</style>
<style scoped>
tbody tr:hover {
  background-color: rgba(0, 153, 130, 0.2);
  cursor: pointer;
}

td div {
  padding: 12px 8px;
  color: #333;
}

.buttonsSearch:hover {
  cursor: pointer;
  background-color: rgba(0, 153, 130, 0.1);
}

.card {
  padding: 20px;
}

.input-group button {
  height: 40px;
}

.botonTotal {
  border: 1px solid #28a745;
  color: #ffffff;
  background-color: #28a745;
  font-weight: 400;
  padding: 8px 16px;
  /* cursor: pointer; */
  margin-bottom: 5px;
  font-size: 14px;
  line-height: 1.42857143;
}

.nombreProducto {
  color: #fff;
  background-color: #0e0e0e;
  text-shadow: 1px 1px #333;
  font-weight: 700;
  font-size: 15px;
}

.tituloPedido {
  color: #1E22AA;
  font-family: "Numier", "Helvetica Neue", Arial;
}

/* .modalCategorySelect {
  width: 25%;
} */

/* .v--modal-overlay.scrollable .v--modal-box .v--modal-overlay {
  flex-direction: column !important ;
  justify-content: center !important ;
  width: 100% !important ;
  max-width: 100% !important ;
  border-radius: 0.3125em !important ;
  background: #fff !important ;
  font-family: inherit !important ;
  font-size: 1rem !important ;
  box-sizing: border-box !important ;
  top: 10%px !important ;
  left: 0px !important ;
  height: auto !important ;
} */

/*@media (min-width: 992px) {
  .v--modal-overlay.scrollable .v--modal-box .v--modal-overlay .v--modal {
    flex-direction: column !important ;
    justify-content: center !important ;
    width: 100% !important ;
    max-width: 100% !important ;
    border-radius: 0.3125em !important ;
    background: #fff !important ;
    font-family: inherit !important ;
    font-size: 1rem !important ;
    box-sizing: border-box !important ;
    top: 10%px !important ;
    left: 0px !important ;
    height: auto !important ;
  }
}*/
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Delivery/Configuracion/Productos/ProductosCarta.vue